import { format } from "date-fns"
import de from "date-fns/locale/de"
import en from "date-fns/locale/en-GB"
import moment from "moment"
import queryString from "query-string"
import * as React from "react"
import { useEffect, useRef, useState } from "react"
import { Col, Container, Modal, Row, Tooltip } from "react-bootstrap"
import ReactDOM from "react-dom"
import Linkify from "react-linkify"
import { useHistory, useLocation } from "react-router-dom"
import Slider from "react-slick"
import VizSensor from "react-visibility-sensor"
import styled from "styled-components"
import { isUserEdited } from "../../../App"
import { syncFavorites } from "../../../backendServices/FavoritesServices"
import {
    AccessProvider,
    Attachment,
    Category,
    Channel,
    Company,
    Description,
    EntityType,
    EventDate,
    Exhibitor,
    JobOffer,
    Link,
    News,
    Person,
    Product,
    ShareTargetType,
    SocialMedia,
    Stand,
    Trademark
} from "../../../backendServices/Types"
import { BasisPremiumType, getBasisPremiumConfig } from "../../../branding/BasisPremiumBranding"
import branding from "../../../branding/branding"
import { useChimeContext } from "../../../conference/context/ChimeContext"
import { useMeetingContext } from "../../../conference/context/MeetingContext"
import { useAppState } from "../../../globalStates/AppState"
import { useCategoriesState } from "../../../globalStates/CategoriesState"
import { useFavoriteState } from "../../../globalStates/Favorites"
import { getIamPartOf } from "../../../globalStates/IAmPartOf"
import { useLanguageState } from "../../../globalStates/LanguageState"
import { useLoggedInState } from "../../../globalStates/LoggedInUser"
import { useUserRestrictedAreaAccess } from "../../../globalStates/UserRestrictedAreaAccess"
import { onAppDownloadClick } from "../../../MobileWebsiteCheck"
import BadgeArea from "../../../ui/BadgeArea"
import BookmarkWithToggle from "../../../ui/BookmarkWithToggle"
import CalendarEntryModal, { CalendarEntryModalViewMode } from "../../../ui/CalendarEntryModal"
import PersonComponent from "../../../ui/carousels/components/PersonComponent"
import { ConditionalWrapper } from "../../../ui/ConditionalWrapper"
import RecommendModal from "../../../ui/RecommendModal"
import ContextMenu, { MenuItemProps } from "../../../ui/ContextMenu"
import {
    IconShowMore,
    IconShowLess,
    IconArrowDownLangSwitcher,
    IconArrowLeftCarousel,
    IconArrowRightCarousel,
    IconArrowUpLangSwitcher,
    IconBookmarkFilled,
    IconBookmarkToggle,
    IconCameraJoin,
    IconContact,
    IconCoupon,
    IconEmail,
    IconFacebook,
    IconFacebookOriginal,
    IconHallplan,
    IconInfo,
    IconInstagram,
    IconInstagramOriginal,
    IconLink,
    IconLinkedIn,
    IconLinkedInOriginal,
    IconLiveStream,
    IconLocation,
    IconLock,
    IconMeetingSchedule,
    IconMobile,
    IconPhone,
    IconPinterest,
    IconPinterestOrginal,
    IconShare,
    IconShareLink,
    IconThreeDotsMenu,
    IconTicket,
    IconTwitter,
    IconVideo,
    IconXing,
    IconXingOriginal,
    IconYouTube,
    IconYouTubeOriginal
} from "../../../ui/Icons"
import LiveEvent from "../../../ui/LiveEvent"
import { usePrivacyPolicyModal } from "../../../ui/PrivacyPolicyModal"
import { useRecommendModal } from "../../../ui/RecommendModal"
import SayHelloModal from "../../../ui/SayHelloModal"
import ScrollBarComponent from "../../../ui/ScrollBar"
import { ContentScrollContainer } from "../../../ui/ScrollContainer"
import { Staff, StaffEntry, StaffType } from "../../../ui/StaffEntry"
import TileRow from "../../../ui/TileRow"
import useWindowDimensions from "../../../ui/WindowDimensionsHook"
import { isEventDateLive } from "../../../utils/DateUtils"
import { DesktopVersionContainer, device, MobileVersionContainer } from "../../../utils/Device"
import {
    isExplorationOrPostEventPhase,
    isExplorationPhase,
    isLivePhase,
    isPostEventPhase
} from "../../../utils/EventPhaseChecker"
import { buildHallplanLink } from "../../hallplan/HallplanNavLink"
import MeetingRoomGroup from "../../lounges/MeetingRoomGroup"
import { SocialMediaType } from "../../myprofile/MyProfilePageContentBranding"
import { PointsBadge } from "../../program/EventDateEntry"
import { MobileTileWrapperSpeakers } from "../../reception/ReceptionPageContent"
import VideoPlayerReal from "../../videoPlayer/VideoPlayerReal"
import { buildDetailLink, DetailNavLink } from "../DetailNavLink"
import { DetailSection, InfoContentOrderType } from "../DetailPageBranding"
import { JobOfferDetails } from "../JobOfferDetailPageContent"
import { hasAvailableStaff, joinShowroom } from "../OrganizationDetailPageContent"
import Categories from "./Categories"
import { DetailPageEntityRow, DetailPageEntityRows, EntityRowData } from "./DetailPageEntityRows"
import { filterMedia, Media, MediaSlider, MediaSliderForMobileView } from "./Media"
import ProductDetailInfo from "./ProductDetailInfo"
import { FormattedDateExtensionDiv, FormattedDatePar, HeaderTitle } from "./StyledComponents"
import CompanyDetails from "../../../ui/CompanyDetails"
import { CustomOverlayTrigger } from "../../../ui/CustomOverlayTrigger"
import { Persons } from "../EventDateDetailPageContent"
import { trackVisit } from "../../../backendServices/TrackingServices"
import { getProperUrl } from "../PersonDetailPageContent"
import { hallplanOverviewRoute } from "../../../navigationArea/RoutePaths"

// export const getNewsDateFormatted = (date: string, lang: string) => {
//     if (lang === "de") return moment(date).format("DD.MM.YYYY")
//     return moment(date).format("DD MMM yyyy")
// }

export const getNewsDateFormatted = (date: string, lang: string) => {
    if (date)
        return format(moment(date).toDate(), branding.eventTiming.eventDaysFormatPatternNewsPage, {
            locale: lang === "de" ? de : en
        })
}

const allowedNumberOfItemsMap = {
    [BasisPremiumType.NONE]: {
        products: branding.organizationDetailPageContent.numberOfProductsNone,
        trademarks: branding.organizationDetailPageContent.numberOfTrademarksNone,
        news: branding.organizationDetailPageContent.numberOfNewsNone
    },
    [BasisPremiumType.BASIC]: {
        products: branding.organizationDetailPageContent.numberOfProductsBasic,
        trademarks: branding.organizationDetailPageContent.numberOfTrademarksBasic,
        news: branding.organizationDetailPageContent.numberOfNewsBasic
    },
    [BasisPremiumType.STANDARD]: {
        products: branding.organizationDetailPageContent.numberOfProductsStandard,
        trademarks: branding.organizationDetailPageContent.numberOfTrademarksStandard,
        news: branding.organizationDetailPageContent.numberOfNewsStandard
    },
    [BasisPremiumType.PREMIUM]: {
        products: branding.organizationDetailPageContent.numberOfProductsPremium,
        trademarks: branding.organizationDetailPageContent.numberOfTrademarksPremium,
        news: branding.organizationDetailPageContent.numberOfNewsPremium
    },
    [BasisPremiumType.ULTIMATE]: {
        products: branding.organizationDetailPageContent.numberOfProductsUltimate,
        trademarks: branding.organizationDetailPageContent.numberOfTrademarksUltimate,
        news: branding.organizationDetailPageContent.numberOfNewsUltimate
    },
    [BasisPremiumType.SPONSOR]: {
        products: -1,
        trademarks: -1,
        news: -1
    }
}

interface OrgaEntities {
    products: Product[]
    trademarks: Trademark[]
    news: News[]
}

const filterEntities = (organization: Company): OrgaEntities => {
    const allowedNumberOfItemsMapObject = allowedNumberOfItemsMap[organization.basisPremium as BasisPremiumType]
    const allowedNumProducts = allowedNumberOfItemsMapObject?.products
    const allowedNumTrademarks = allowedNumberOfItemsMapObject?.trademarks
    const allowedNumNews = allowedNumberOfItemsMapObject?.news
    let productsFiltered = organization.products
    let trademarksFiltered = organization.trademarks
    let newsFiltered = organization.news

    if (allowedNumProducts && allowedNumProducts > -1) productsFiltered = productsFiltered?.slice(0, allowedNumProducts)
    if (allowedNumTrademarks && allowedNumTrademarks > -1) trademarksFiltered = trademarksFiltered?.slice(0, allowedNumTrademarks)
    if (allowedNumNews && allowedNumNews > -1) newsFiltered = newsFiltered?.slice(0, allowedNumNews)

    return {
        products: productsFiltered,
        trademarks: trademarksFiltered,
        news: newsFiltered
    }
}
interface OrgaTransformedEntities {
    products: EntityRowData[]
    trademarks: EntityRowData[]
    news: EntityRowData[]
}

const mapEntities = (entities: OrgaEntities): OrgaTransformedEntities => {
    const products = entities.products?.map((product) => product as EntityRowData)
    const trademarks = entities.trademarks?.map((trademark) => trademark as EntityRowData)
    const news = entities.news?.map((news) => {
        const entityRow = news as EntityRowData
        entityRow.name = news.title
        entityRow.description = { teaser: news.teaser }
        return entityRow
    })

    return {
        products: products,
        trademarks: trademarks,
        news: news
    }
}

const transformOrgaSubEntities = (organization: Company): OrgaTransformedEntities => {
    const filteredEntites = filterEntities(organization)
    return mapEntities(filteredEntites)
}

const ContentWrapper = styled.div<{ isScrollable: boolean }>`
    & .ScrollbarsCustom-Scroller {
        margin-right: ${(props) => (props.isScrollable ? "-21px !important" : "unset !important")};
        padding-right: ${(props) => (props.isScrollable ? "20px" : "unset")};
    }

    & .ScrollbarsCustom-Content {
        background: ${branding.myProfilePageContent.mobilePageBackgroundColor};
    }

    @media ${device.tablet} {
        & .ScrollbarsCustom-Content {
            background: #fff;
        }
    }

    @media ${device.laptop} {
        & .ScrollbarsCustom-Scroller {
            margin-right: -30px !important;
        }
    }
`

const OrganizationDetailPageContentRoot = styled.div`
    padding: 0px;
    font-family: ${branding.font1};

    @media (max-width: 1400px) {
        padding: 0px 100px;
    }

    @media ${device.mobile} {
        padding: 10px;
        padding-bottom: 60px;
        background: ${branding.myProfilePageContent.mobilePageBackgroundColor};

        @supports (-webkit-touch-callout: none) {
            padding-bottom: 250px;
        }
    }

    @media ${device.tablet} {
        background: #fff;
    }
`

const MobileSectionWrapper = styled.div`
    width: 100%;
    background: #fff;
    margin-bottom: 10px;
    border-radius: 5px;
`

const CompanyLogoDiv = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #d9d9d9;
    border-radius: 5px;
    width: 150px;
    height: 150px;
    padding: 20px;
    background: #fff;

    @media (max-width: 1600px) {
        width: 120px;
        height: 120px;
        padding: 25px;
    }

    @media (max-width: 1400px) {
        width: 100px;
        height: 100px;
        padding: 15px;
    }

    @media (max-width: 1200px) {
        width: 80px;
        height: 80px;
        padding: 10px;
    }
`

const CompanyLogo = styled.img`
    object-fit: contain;
    width: 100%;
    height: 100%;
`

const RowTileParent = styled.div`
    & .title-no-link {
        font-size: 18px;
    }
`

const RemoteLivestreamTile = styled.div`
    position: relative;
    height: 16.875vw; // width * 0.5625 - aspect ratio 16:9
    width: 30vw;
    color: white !important;
    margin: 0px 10px 20px 0px;
    border: 1px solid #000;
    border-radius: 5px;
`

export const MediaRow = styled(Row)`
    padding-bottom: 3rem !important;
    @media ${device.tablet} {
        margin-top: 3rem !important;
        padding-bottom: 3rem !important;
        &.product {
            margin-top: 50px !important;
        }
    }
`

interface DetailPageSectionsProps {
    type: EntityType
    guestUserBannerRef?: React.RefObject<HTMLDivElement>
    handleScroll?(value: number): void
    onAccessDenied?: () => void

    entity: Company | Product | Trademark | News | JobOffer
    adjustHeightWith?: number
    setShowGuestModal?: (value: boolean) => void
}

const TeamSessionTemplateRow = styled(Row)`
    @media ${device.tablet} {
        margin-top: 3rem;
        margin-bottom: 3rem;
    }
`

export const LinksRow = styled(Row)`
    margin-left: -15px;
    margin-right: -15px;

    @media ${device.mobile} {
        margin-left: 5px;
        margin-right: 5px;
    }

    @media ${device.tablet} {
        padding: 0px 12px 12px;
    }
`

const CompanyWrapper = styled.div`
    padding: 10px 0;
`

const DetailPageSections: React.FunctionComponent<DetailPageSectionsProps> = (props) => {
    const langState = useLanguageState()
    const strings = langState.getStrings()
    const lang = langState.getLanguage()
    const appState = useAppState()
    const history = useHistory()
    const { RecommendModal, showRecommendModal } = useRecommendModal()

    const [isContentScrollable, setIsContentScrollable] = useState(false)

    //Main content container reference
    const containerRef = useRef<HTMLDivElement>(null)
    const [containerOffsetLeft, setContainerOffsetLeft] = useState<number | undefined>()
    const isNetworkingOpen = appState.isNetworkingOpen()

    useEffect(() => {
        setContainerOffsetLeft(containerRef.current?.offsetLeft)
    }, [window.innerWidth, isNetworkingOpen]) // eslint-disable-line

    const [meetingRoomGroups, setMeetingRoomGroups] = useState<any[]>([])
    const userAccessState = useUserRestrictedAreaAccess()

    let sectionOrder: DetailSection[] = []
    let infoContentOrder: InfoContentOrderType[] = []
    let organizationId: string | undefined
    let organization: Company | undefined
    let product: Product | undefined
    let trademark: Trademark | undefined
    let news: News | undefined
    let joboffer: JobOffer | undefined
    let organizations: Company[] = []
    let joboffers: JobOffer[] = []
    let persons: Person[] = []
    let stands: Stand[] = []
    let products: EntityRowData[] = []
    let trademarks: EntityRowData[] = []
    let orgaNews: EntityRowData[] = []
    let liveChannels: Channel[] = []
    let liveSessions: EventDate[] = [] // for live eventdates without channel (e.g. roundtable)
    let previousSessions: EventDate[] = []
    let upcomingSessions: EventDate[] = []
    let iframe: string
    let config: any
    let categories: Category[] = []
    let showCategoryHierarchy: boolean = false

    const { isMobile } = useWindowDimensions()

    useEffect(() => {
        setMeetingRoomGroups(strings.meetingRoomGroups)
        userAccessState.fetchUserAccessForAllRestrictedAreaTypes()
        // eslint-disable-next-line
    }, [])

    switch (props.type) {
        case "organization":
            organization = props.entity as Company
            config = getBasisPremiumConfig(organization?.basisPremium! as BasisPremiumType)
            const orgaEntities = transformOrgaSubEntities(organization)
            products = orgaEntities.products
            trademarks = orgaEntities.trademarks
            orgaNews = orgaEntities.news
            iframe = lang === "en" ? organization.iframeUrl : organization.iframeUrlDe
            sectionOrder = branding.organizationDetailPageContent.orgaDetailPageMainContentOrder
            infoContentOrder = branding.organizationDetailPageContent.orgaDetailPageInfoSectionOrder
            organizationId = props.entity.id
            categories = organization.categories
            showCategoryHierarchy = branding.organizationDetailPageContent.showCategoryHierarchy
            joboffers = organization.joboffers
            stands = organization.stands
            const now = moment()
            if (organization.eventDates) {
                organization.eventDates.forEach((eventDate) => {
                    if (isEventDateLive(eventDate)) {
                        if (eventDate.channel) {
                            const channel: Channel = { ...eventDate.channel, currentEventDate: eventDate }
                            liveChannels.push(channel)
                        } else liveSessions.push(eventDate)
                    } else if (moment(eventDate.date + " " + eventDate.start).isAfter(now)) {
                        upcomingSessions.push(eventDate)
                    } else if (moment(eventDate.date + " " + eventDate.end).isBefore(now)) {
                        previousSessions.push(eventDate)
                    }
                })
            }
            break
        case "product":
            product = props.entity as Product
            organization = product.organizations[0] || null
            organizations = product.organizations
            sectionOrder = branding.productDetailPageContent.sectionOrder
            infoContentOrder = branding.productDetailPageContent.infoContentOrder
            categories = product.categories
            stands = product.stands
            showCategoryHierarchy = branding.productDetailPageContent.showCategoryHierarchy
            if ((props.entity as Product).organizations?.length) {
                organization = (props.entity as Product).organizations[0]
                organizationId = (props.entity as Product).organizations[0].id
            }
            break
        case "trademark":
            trademark = props.entity as Trademark
            organizations = trademark.organizations
            sectionOrder = branding.trademarkDetailPageContent.sectionOrder
            infoContentOrder = branding.trademarkDetailPageContent.infoContentOrder
            categories = trademark.categories
            showCategoryHierarchy = branding.trademarkDetailPageContent.showCategoryHierarchy
            if ((props.entity as Trademark).organizations?.length) {
                organization = (props.entity as Trademark).organizations[0]
                organizationId = (props.entity as Trademark).organizations[0].id
            }
            break
        case "news":
            news = props.entity as News
            news.pictureURL = news.logoUrl
            organization = news.organization
            organizations = [news.organization]
            sectionOrder = branding.newsDetailPageContent.sections
            infoContentOrder = branding.newsDetailPageContent.infoContentOrder
            showCategoryHierarchy = branding.newsDetailPageContent.showCategoryHierarchy
            categories = news.categories
            persons = news.persons
            if (news.organization) organizationId = news.organization.id
            break
        case "joboffer":
            joboffer = props.entity as JobOffer
            persons = joboffer.persons
            organization = joboffer.organization
            sectionOrder = branding.jobofferDetailPageContent.sections
            infoContentOrder = branding.jobofferDetailPageContent.infoContentOrder
            organizationId = joboffer.organization.id
            break
        default:
            return null
    }

    return (
        <ContentWrapper isScrollable={isContentScrollable}>
            <ContentScrollContainer
                setIsScrollable={setIsContentScrollable}
                handleScroll={props.handleScroll}
                adjustForHeaderWith={
                    isMobile
                        ? "0px"
                        : props.guestUserBannerRef && props.guestUserBannerRef.current
                        ? props.guestUserBannerRef.current.clientHeight + (props.adjustHeightWith ?? 0) + "px"
                        : (props.adjustHeightWith ?? 0) + "px"
                }
            >
                <OrganizationDetailPageContentRoot>
                    <MobileVersionContainer>
                        {props.type === "organization" && <MobileCompanyHeader company={organization} />}
                        {(props.type === "product" || props.type === "trademark" || props.type === "joboffer") && (
                            <MobileProductHeader entity={props.entity as Product | Trademark | JobOffer} type={props.type} />
                        )}
                    </MobileVersionContainer>

                    <ConditionalWrapper
                        wrapper={(children) =>
                            isMobile ? (
                                <div>{children}</div>
                            ) : (
                                <Container
                                    ref={containerRef}
                                    className="mt-5"
                                    style={{ color: branding.mainInfoColor, width: "100%" }}
                                >
                                    {children}
                                </Container>
                            )
                        }
                    >
                        {sectionOrder.map((item, index) => {
                            /* Company logo and detail information */
                            if (item === DetailSection.DETAIL_INFO) {
                                return (
                                    <>
                                        {props.type === "product" ? (
                                            <DesktopVersionContainer>
                                                <ProductDetailInfo key={index} product={product} />
                                            </DesktopVersionContainer>
                                        ) : (
                                            <DetailInfo
                                                type={props.type}
                                                key={index}
                                                order={infoContentOrder}
                                                company={organization}
                                                joboffer={joboffer}
                                                containerOffsetLeft={containerOffsetLeft}
                                                newsDate={props.type === "news" ? news?.date : undefined}
                                                categories={categories}
                                                persons={persons}
                                                showCategoryHierarchy={showCategoryHierarchy}
                                                {...props.entity}
                                                showRecommendModal={showRecommendModal}
                                            />
                                        )}
                                    </>
                                )
                            }

                            /* Company team */
                            if (item === DetailSection.TEAM && organization?.persons?.length) {
                                return (
                                    config.teamMembersVisible && (
                                        <MobileSectionWrapper>
                                            <TeamSessionTemplateRow key={index}>
                                                <TeamSessionsTemplate
                                                    type="team"
                                                    team={organization.persons}
                                                    organizationId={organization.id}
                                                    organizationName={organization.name}
                                                    organization={organization}
                                                    onAccessDenied={props.onAccessDenied}
                                                    containerOffsetLeft={containerOffsetLeft}
                                                />
                                            </TeamSessionTemplateRow>
                                        </MobileSectionWrapper>
                                    )
                                )
                            }

                            if (item === DetailSection.PERSONS && persons?.length && joboffer) {
                                return (
                                    <MobileSectionWrapper>
                                        <TeamSessionTemplateRow key={index}>
                                            <TeamSessionsTemplate
                                                type="team"
                                                team={persons}
                                                organizationId={joboffer.organization.id}
                                                organizationName={strings.jobofferDetailPageContent.personListTitle}
                                                organization={joboffer.organization}
                                                onAccessDenied={props.onAccessDenied}
                                                containerOffsetLeft={containerOffsetLeft}
                                            />
                                        </TeamSessionTemplateRow>
                                    </MobileSectionWrapper>
                                )
                            }

                            if (item === DetailSection.HALLE_STAND_INFO && props.type === "product" && stands && stands.length) {
                                return (
                                    <DesktopVersionContainer key={index}>
                                        <HalleStandSection hasSocials={false} className="product">
                                            <HeaderTitle className="mt-0" style={{ marginBottom: "15px" }}>
                                                {strings.productDetailPageContent.halleStandSectionTitle}
                                            </HeaderTitle>
                                            {stands.map((stand, idx) => {
                                                return (
                                                    <HalleStandSingle
                                                        onClick={() => {
                                                            if (!branding.organizationDetailPageContent.halleStandLinkEnabled)
                                                                return

                                                            history.push(
                                                                hallplanOverviewRoute +
                                                                    "/" +
                                                                    stand.id.split("__")[0] +
                                                                    "--" +
                                                                    stand.id
                                                            )
                                                        }}
                                                        key={idx}
                                                    >
                                                        {stand.standName || stand.displayName}
                                                    </HalleStandSingle>
                                                )
                                            })}
                                        </HalleStandSection>
                                    </DesktopVersionContainer>
                                )
                            }

                            /* Now live section */
                            if (item === DetailSection.LIVE_SESSIONS && (liveChannels.length || liveSessions.length)) {
                                return (
                                    <DesktopVersionContainer key={index}>
                                        {liveChannels && liveChannels.length > 0 && (
                                            <RowTileParent>
                                                <TileRow
                                                    title={strings.receptionPage.liveSessions}
                                                    height="220px"
                                                    titleNoLink={strings.receptionPage.nowLive + " (" + liveChannels.length + ")"}
                                                    tileRowMargin="0"
                                                    offsetLeft={containerOffsetLeft}
                                                    scrollBar
                                                    childWidth={480}
                                                    childCount={liveChannels.length}
                                                    hideShadows={true}
                                                    customWidth="auto"
                                                >
                                                    {liveChannels.map((channel) => (
                                                        <VizSensor key={channel.id} partialVisibility={true}>
                                                            {({ isVisible }) =>
                                                                isVisible ? (
                                                                    <LiveEvent
                                                                        id={index.toString()}
                                                                        title={channel.name}
                                                                        thumbnailUrl={channel.thumbnailUrl}
                                                                        channelId={channel.id}
                                                                        channelIcon={IconLiveStream({ fill: "#fff" })}
                                                                        eventDate={channel.currentEventDate}
                                                                        setShowGuestModal={props.setShowGuestModal!}
                                                                        rerenderOnUnlockedChanged={userAccessState.isUnlocked(
                                                                            channel.currentEventDate
                                                                        )}
                                                                    />
                                                                ) : (
                                                                    <div style={{ width: 480, height: 280 }}></div>
                                                                )
                                                            }
                                                        </VizSensor>
                                                    ))}
                                                </TileRow>
                                            </RowTileParent>
                                        )}
                                        {liveSessions && liveSessions.length > 0 && (
                                            <Row key={index} className="mt-5 pb-5">
                                                <TeamSessionsTemplate
                                                    type="session"
                                                    sessions={liveSessions}
                                                    organizationId={organizationId!}
                                                    organization={organization!}
                                                    live={true}
                                                />
                                            </Row>
                                        )}
                                    </DesktopVersionContainer>
                                )
                            }

                            /* Upcoming sessions */
                            if (item === DetailSection.UPCOMING_SESSIONS && upcomingSessions?.length) {
                                return (
                                    <DesktopVersionContainer key={index}>
                                        <Row key={index} className="mt-5 pb-5">
                                            <TeamSessionsTemplate
                                                type="session"
                                                sessions={upcomingSessions}
                                                organizationId={organizationId!}
                                                organization={organization!}
                                                past={false}
                                            />
                                        </Row>
                                    </DesktopVersionContainer>
                                )
                            }

                            /* Previous sessions */
                            if (item === DetailSection.PREVIOUS_SESSIONS && previousSessions?.length) {
                                return (
                                    <DesktopVersionContainer key={index}>
                                        <Row key={index} className="mt-5 pb-5">
                                            <TeamSessionsTemplate
                                                type="session"
                                                sessions={previousSessions}
                                                organizationId={organizationId!}
                                                organization={organization!}
                                                past={true}
                                            />
                                        </Row>
                                    </DesktopVersionContainer>
                                )
                            }

                            /* Categories */
                            if (
                                item === DetailSection.CATEGORIES &&
                                categories &&
                                categories.length &&
                                filterCategories(categories || []).length > 0
                            ) {
                                return (
                                    <MobileSectionWrapper>
                                        <Categories
                                            key={index}
                                            categories={filterCategories(categories)}
                                            categoryType={props.type}
                                        />
                                    </MobileSectionWrapper>
                                )
                            }

                            /* Virtual cafes */
                            if (item === DetailSection.VIRTUAL_CAFES && organization) {
                                if (organization.basisPremium === BasisPremiumType.NONE) return null

                                const orgaMeetingRoomGroups = meetingRoomGroups.filter(
                                    (x) => x.organizationId === organization!.id || x.secondOrganizationId === organization!.id
                                )
                                return (
                                    <DesktopVersionContainer key={index}>
                                        {orgaMeetingRoomGroups.length !== 0 && (
                                            <RowTileParent>
                                                <TileRow
                                                    title={strings.organizationDetailPageContent.virtualCafesTitle}
                                                    height="220px"
                                                    offsetLeft={containerOffsetLeft}
                                                    scrollBar
                                                    childWidth={500 + 4}
                                                    childCount={orgaMeetingRoomGroups.length}
                                                    tileRowMargin="50px 0"
                                                    hideShadows={true}
                                                >
                                                    {orgaMeetingRoomGroups.map((meetingRoomGroup) => (
                                                        <MeetingRoomGroupContainer key={meetingRoomGroup.id}>
                                                            <MeetingRoomGroup
                                                                source="ORG_DETAIL"
                                                                meetingRoomGroupConfig={meetingRoomGroup}
                                                                roomType="virtualCafe"
                                                                rerenderOnUnlockedChanged={userAccessState.isUnlocked(
                                                                    meetingRoomGroup
                                                                )}
                                                            />
                                                        </MeetingRoomGroupContainer>
                                                    ))}
                                                </TileRow>
                                            </RowTileParent>
                                        )}
                                    </DesktopVersionContainer>
                                )
                            }

                            /* Company Links */
                            if (item === DetailSection.LINKS && props.entity.links?.length) {
                                return (
                                    <MobileSectionWrapper>
                                        <LinksRow key={index}>
                                            <Links
                                                organizationId={organizationId}
                                                organization={organization}
                                                links={props.entity.links}
                                                tooltipMessage={strings.organizationDetailPageContent.copyToClipboardText}
                                            />
                                        </LinksRow>
                                    </MobileSectionWrapper>
                                )
                            }

                            /* Media */
                            if (item === DetailSection.MEDIA && props.entity.attachments?.length) {
                                return (
                                    <MobileSectionWrapper>
                                        <MediaRow key={index} className={props.type === "product" ? "product" : "pb-5"}>
                                            <Media
                                                media={props.entity.attachments}
                                                organizationId={organizationId}
                                                organization={organization!}
                                                entityType={props.type}
                                            />
                                        </MediaRow>
                                    </MobileSectionWrapper>
                                )
                            }

                            /* Contact information */
                            if (item === DetailSection.COMPANY_INFORMATION_TITLE) {
                                return (
                                    <MobileSectionWrapper>
                                        <Row key={index} className="mt-5 pb-1" style={{ marginLeft: "5px", marginRight: "5px" }}>
                                            <HeaderTitle>
                                                {strings.organizationDetailPageContent.companyInformationTitle}
                                            </HeaderTitle>
                                        </Row>
                                    </MobileSectionWrapper>
                                )
                            }

                            /* Founding year, size, industry */
                            if (item === DetailSection.COMPANY_DETAILS && organization) {
                                return (
                                    <MobileSectionWrapper key={index} className="mt-3 pb-5">
                                        <CompanyDetailInfo company={organization} />
                                    </MobileSectionWrapper>
                                )
                            }

                            /* Parent exhibitor */
                            if (item === DetailSection.PARENT && organization && organization.parent) {
                                const rowData: EntityRowData = organization.parent
                                return (
                                    <DesktopVersionContainer key={index}>
                                        <div className="mt-5 p-0 mb-4">
                                            <HeaderTitle>{strings.organizationDetailPageContent.parentSectionTitle}</HeaderTitle>
                                        </div>
                                        <DetailPageEntityRow
                                            type={"organization"}
                                            pageType={props.type}
                                            rowData={rowData}
                                            key={rowData.id}
                                        />
                                    </DesktopVersionContainer>
                                )
                            }

                            /* Co-Exhibitors */
                            if (
                                item === DetailSection.CO_EXHIBITORS &&
                                organization &&
                                organization.children &&
                                organization.children.length > 0
                            ) {
                                return (
                                    <DesktopVersionContainer key={index}>
                                        <DetailPageEntityRows
                                            key={index}
                                            type="organization"
                                            pageType={props.type}
                                            headerTitle={strings.organizationDetailPageContent.coExhibitorsSectionTitle}
                                            rowsData={organization.children}
                                        />
                                    </DesktopVersionContainer>
                                )
                            }

                            if (item === DetailSection.COUPONS && organization?.coupons?.length) {
                                return (
                                    <DesktopVersionContainer key={index}>
                                        {
                                            <Row key={index} className="mt-5 pb-5">
                                                <TeamSessionsTemplate
                                                    type="coupon"
                                                    coupons={organization.coupons}
                                                    organizationId={organization.id}
                                                    organization={organization}
                                                />
                                            </Row>
                                        }
                                    </DesktopVersionContainer>
                                )
                            }

                            if (
                                item === DetailSection.PRODUCTS &&
                                products?.length &&
                                (branding.configuration.detailSectionToggle === false || organization?.showProducts)
                            ) {
                                return (
                                    <MobileSectionWrapper>
                                        <DetailPageEntityRows
                                            key={index}
                                            type="product"
                                            pageType={props.type}
                                            headerTitle={strings.sideIconBar.productsSearchDrawerText}
                                            rowsData={products}
                                        />
                                    </MobileSectionWrapper>
                                )
                            }

                            if (
                                item === DetailSection.TRADEMARKS &&
                                trademarks?.length &&
                                (branding.configuration.detailSectionToggle === false || organization?.showTrademarks)
                            ) {
                                return (
                                    <MobileSectionWrapper>
                                        <DetailPageEntityRows
                                            key={index}
                                            type="trademark"
                                            pageType={props.type}
                                            headerTitle={strings.sideIconBar.trademarksSearchDrawerText}
                                            rowsData={trademarks}
                                        />
                                    </MobileSectionWrapper>
                                )
                            }

                            if (item === DetailSection.NEWS && orgaNews && orgaNews.length > 0) {
                                return (
                                    <MobileSectionWrapper>
                                        <DetailPageEntityRows
                                            key={index}
                                            type="news"
                                            pageType={props.type}
                                            headerTitle={strings.sideIconBar.newsSearchDrawerText}
                                            rowsData={orgaNews}
                                        />
                                    </MobileSectionWrapper>
                                )
                            }

                            if (item === DetailSection.ORGANIZATIONS && organizations?.length) {
                                return (
                                    <MobileSectionWrapper>
                                        <DetailPageEntityRows
                                            key={index}
                                            type="organization"
                                            pageType={props.type}
                                            headerTitle={strings.sideIconBar.companiesSearchDrawerText}
                                            rowsData={organizations}
                                        />
                                    </MobileSectionWrapper>
                                )
                            }

                            if (item === DetailSection.SHOWCASE && iframe) {
                                return (
                                    <DesktopVersionContainer key={index}>
                                        <IframeSection src={iframe} title={organization?.id + "-iframe"} />
                                    </DesktopVersionContainer>
                                )
                            }

                            if (
                                item === DetailSection.REMOTE_LIVESTREAMS &&
                                organization &&
                                organization.remoteLivestreams &&
                                organization.remoteLivestreams.length > 0
                            ) {
                                const sectionTitle = strings.organizationDetailPageContent.remoteLivestreamsTitle.replace(
                                    "$count",
                                    organization.remoteLivestreams.length.toString()
                                )
                                return (
                                    <DesktopVersionContainer key={index}>
                                        <RowTileParent>
                                            <TileRow
                                                title={sectionTitle}
                                                titleNoLink={sectionTitle}
                                                tileRowMargin="50px 0"
                                                offsetLeft={containerOffsetLeft}
                                                scrollBar
                                                // converting vw to px: (window.innerWidth * RemoteLivestreamTile.width(30vw)) / 100
                                                // childWidth: Width of the RemoteLivestreamTile in px + 10px margin
                                                childWidth={(window.innerWidth * 30) / 100 + 10}
                                                childCount={organization.remoteLivestreams.length}
                                            >
                                                {organization.remoteLivestreams.map((stream, idx) => (
                                                    <RemoteLivestreamTile key={idx}>
                                                        <VideoPlayerReal
                                                            src={stream.url}
                                                            controls={true}
                                                            live={true}
                                                            remoteLivestream={stream}
                                                            remoteStreamLayout={true}
                                                            disablePlayerStateIsSaved={true}
                                                            sourceIsStatic={false}
                                                        />
                                                    </RemoteLivestreamTile>
                                                ))}
                                            </TileRow>
                                        </RowTileParent>
                                    </DesktopVersionContainer>
                                )
                            }

                            if (item === DetailSection.JOB_OFFERS && joboffers?.length) {
                                return (
                                    <MobileSectionWrapper>
                                        <DetailPageEntityRows
                                            key={index}
                                            type="joboffer"
                                            pageType={props.type}
                                            headerTitle={strings.suggestBoxContent.joboffersGroupTitle}
                                            rowsData={joboffers}
                                            showRecommendModal={showRecommendModal}
                                        />
                                    </MobileSectionWrapper>
                                )
                            }

                            if (item === DetailSection.COMPANY && organization) {
                                return (
                                    <MobileSectionWrapper>
                                        <CompanyWrapper className="company-wrapper">
                                            <CompanyDetails organization={organization} />
                                        </CompanyWrapper>
                                    </MobileSectionWrapper>
                                )
                            }
                            return null
                        })}
                    </ConditionalWrapper>
                </OrganizationDetailPageContentRoot>
            </ContentScrollContainer>
            <RecommendModal />
        </ContentWrapper>
    )
}

export default DetailPageSections

/* #region Company address, phone, email info */
interface CompanyAddressPhoneEmailProps {
    company: Company
}
const CompanyAddressPhoneEmail: React.FunctionComponent<CompanyAddressPhoneEmailProps> = (props) => {
    const componentDecorator = (href: string, text: string, key: number) => (
        <a
            style={{ fontWeight: "bold", color: branding.mainInfoColor }}
            href={href}
            key={key}
            target="_blank"
            rel="noopener noreferrer"
        >
            {text}
        </a>
    )

    return (
        <div style={{ display: "flex", flex: 2 }}>
            <DetailsAdditionalInfoDiv style={{ flex: 1, display: "flex", flexDirection: "row" }}>
                <div style={{ paddingRight: "10px" }}>
                    {(props.company.name || props.company.adress1 || props.company.postCode || props.company.country) &&
                        IconLocation({ fill: branding.sideIconBar.sideIconColorDark, width: "20", height: "20" })}
                </div>
                <div>
                    <p>{props.company.name}</p>
                    {props.company.adress1 && <p>{props.company.adress1}</p>}
                    {props.company.adress2 && <p>{props.company.adress2}</p>}
                    {props.company.adress3 && <p>{props.company.adress3}</p>}
                    <p>
                        {props.company.postCode} {props.company.city}
                    </p>
                    <p>{props.company.country}</p>
                </div>
            </DetailsAdditionalInfoDiv>

            <DetailsAdditionalInfoDiv style={{ flex: 1, display: "flex", flexDirection: "row" }}>
                <div style={{ paddingRight: "10px" }}>
                    {(props.company.phone || props.company.email || props.company.web) &&
                        IconContact({ fill: branding.sideIconBar.sideIconColorDark, width: "20", height: "20" })}
                </div>
                <div>
                    {props.company.phone && !branding.organizationDetailPageContent.hideTelephone && <p>{props.company.phone}</p>}
                    {props.company.email && !branding.organizationDetailPageContent.hideEmailAddress && (
                        <p>
                            <Linkify componentDecorator={componentDecorator}>{props.company.email}</Linkify>
                        </p>
                    )}
                    {props.company.web && (
                        <p>
                            <Linkify componentDecorator={componentDecorator}>{props.company.web}</Linkify>
                        </p>
                    )}
                </div>
            </DetailsAdditionalInfoDiv>
        </div>
    )
}
/* #endregion */

/* #region  Company Detail Info */
const CompanyTeaser = styled.p`
    font-size: ${branding.organizationDetailPageContent.companyTeaserFontSize};
    font-weight: 400;
    white-space: pre-line;

    &.news {
        @media ${device.tablet} {
            width: 90%;
        }

        @media ${device.mobile} {
            font-size: 14px;
            line-height: 18px;
            font-weight: 400;
        }
    }
`

const NewsSubheadline = styled.p`
    font-size: 18px;
    font-weight: 600;
    white-space: pre-line;

    @media ${device.mobile} {
        font-size: 14px;
        line-height: 18px;
        font-weight: 400;
        font-style: italic;
    }
`

const NewsDate = styled.p`
    font-size: 12px;
    margin-bottom: 10px;

    @media ${device.tablet} {
        margin-bottom: 20px;
    }

    @media ${device.laptopL} {
        font-size: 14px;
    }

    @media ${device.desktop} {
        font-size: 16px;
        margin-bottom: 25px;
    }
`

const TalkWithTeamDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    margin-top: 50px;
    border: 1px solid ${branding.mainInfoColor};
    border-radius: 5px;
    height: 100px;
    font-size: 16px;
    position: relative;

    @media (max-width: 1600px) {
        font-size: 14px;
    }
`

const JoinButtonCol = styled(Col)`
    background: ${branding.mainInfoColor};
    font-family: ${branding.font1};
    border-radius: 5px;
    height: 65%;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    ${(props) => (props.disabled ? "opacity: 0.5; pointer-events: none;" : "")}

    :hover {
        color: #fff;
        background-color: ${branding.meetingRoomGroupsRequestAccessButtonBgColorOnHover};
        border-color: ${branding.meetingRoomGroupsRequestAccessButtonBgColorOnHover};
    }
`
const ExplorationPhaseMessage = styled.div`
    position: absolute;
    bottom: 0;
    left: 110px;
    color: rgb(189, 189, 189);
    font-family: ${branding.font1};
    @media (max-width: 1600px) {
        left: 80px;
        font-size: 14px;
    }

    @media (max-width: 1400px) {
        font-size: 12px;
        left: 50px;
    }
`

const MeetingRoomGroupContainer = styled.div`
    margin-bottom: 1.25rem;
`

const CompanyInfoParagraph = styled.p<{ lang?: string }>`
    width: auto;
    min-width: ${(props) => (props.lang === "de" ? "135px" : "105px")};
    margin-right: 15px;
    font-weight: bold;
`

const HalleStandSection = styled.div<{ hasSocials?: boolean }>`
    padding: 25px 0;
    border-top: ${branding.mainBorder ? branding.mainBorder : "1px solid #d9d9d9"};
    border-bottom: ${branding.mainBorder ? branding.mainBorder : "1px solid #d9d9d9"};
    margin-top: ${(props) => (props.hasSocials === true ? "40px" : "0px")};

    &.product {
        border: none;
        padding-top: 50px;
        padding-left: 10px;
    }
`
const HalleStandSectionMobileView = styled.div`
    width: 400px;

    &.product {
        margin-top: 15px;

        p {
            font-size: 14px !important;
        }
    }
`

const HalleStandSingle = styled.div`
    display: inline-block;
    padding: 10px 30px;
    margin-right: 10px;
    margin-top: 10px;
    border-radius: 5px;
    text-align: center;
    background-color: ${branding.organizationDetailPageContent.halleStandItemBgColor};
    color: ${branding.organizationDetailPageContent.halleStandItemColor};
    cursor: ${branding.organizationDetailPageContent.halleStandLinkEnabled ? "pointer" : "auto"};
    pointer-events: ${branding.organizationDetailPageContent.halleStandLinkEnabled ? "auto" : "none"};
`
const HalleStandSingleMobileView = styled.div`
    display: inline-block;
    padding: 10px 30px;
    margin-right: 10px;
    margin-top: 20px;
    border-radius: 5px;
    text-align: center;
    background-color: ${branding.organizationDetailPageContent.halleStandItemBgColor};
    color: ${branding.organizationDetailPageContent.halleStandItemColor};
    cursor: ${branding.organizationDetailPageContent.halleStandLinkEnabled ? "pointer" : "auto"};
    pointer-events: ${branding.organizationDetailPageContent.halleStandLinkEnabled ? "auto" : "none"};
    width: 250px;

    &.product {
        margin-top: 0px;
    }
`
interface DetailInfoProps {
    type: EntityType
    order: InfoContentOrderType[]
    company?: Company
    description?: Description
    joboffer?: JobOffer
    pictureURL?: string
    name?: string
    initials?: string
    socialMedias?: SocialMedia[]
    containerOffsetLeft: number | undefined
    newsDate?: string
    categories?: Category[]
    persons?: Person[]
    showCategoryHierarchy: boolean
    id: string
    showRecommendModal?: (shareType: ShareTargetType, entityId: string, link: string) => void
}

export function getSimpleCategories(categories: Category[], showCategoryHierarchy: boolean): Category[] {
    if (!showCategoryHierarchy) {
        return categories
    }

    const simpleCategories: Category[] = []

    categories.forEach((category: Category) => {
        if (category.nodes && category.nodes?.length > 0) {
            let categoriesTemp = getSimpleCategories(category.nodes || [], showCategoryHierarchy)

            categoriesTemp.forEach((categoryTemp: Category) => {
                simpleCategories.push(categoryTemp)
            })
        } else {
            simpleCategories.push(category)
        }
    })

    return simpleCategories
}

function checkIfAllSyntheticNodes(nodes: Category[]): boolean {
    if (nodes.length === 0) {
        return false
    }

    let nodesTemp = nodes?.filter((node) => !node.isSynthetic)

    return nodesTemp.length === 0
}

export function filterCategories(categories: Category[]): Category[] {
    let categoriesToFilter: Category[] = []

    categories.forEach((category: Category) => {
        categoriesToFilter.push(Object.assign({}, category))
    })

    categoriesToFilter = categoriesToFilter?.filter(
        (category) => !category.isSynthetic && !checkIfAllSyntheticNodes(category.nodes || [])
    )

    categoriesToFilter.forEach((category: Category) => {
        if (category.nodes && category.nodes?.length > 0) {
            category.nodes = category.nodes?.filter((node) => !node.isSynthetic && !checkIfAllSyntheticNodes(node.nodes || []))

            category.nodes?.forEach((node: Category) => {
                if (node.nodes) {
                    node.nodes = filterCategories(node.nodes)
                }
            })
        }
    })

    return categoriesToFilter
}

const InfoRow = styled(Row)`
    margin-top: 30px;

    @media ${device.mobile} {
        padding: 10px 20px 10px 10px;
        margin-top: 0;
    }
`
const DetailInfo: React.FunctionComponent<DetailInfoProps> = (props) => {
    const chime = useChimeContext()
    const meeting = useMeetingContext()
    const languageState = useLanguageState()
    const strings = languageState.getStrings()
    const loggedInUser = useLoggedInState().user()
    const { showPrivacyPolicyModal, PrivacyModal } = usePrivacyPolicyModal()
    const queryParams: any = queryString.parse(window.location.search)
    const { company, joboffer } = props
    let config = getBasisPremiumConfig(props.company?.basisPremium! as BasisPremiumType)
    const userAccessState = useUserRestrictedAreaAccess()
    const { useMobileDesign } = useWindowDimensions()

    const [targetId, setTargetId] = useState<string>("")
    const [link, setLink] = useState<string>("")
    const [type, setType] = useState<ShareTargetType>()
    const [showRecommendOrganizationModal, setShowRecommendOrganizationModal] = useState(false)

    const history = useHistory()

    const DesktopInfo = (
        <MobileSectionWrapper>
            <InfoRow>
                <Col xs={useMobileDesign ? 3 : 2}>
                    <CompanyLogoDiv>
                        {props.pictureURL ? (
                            <CompanyLogo src={props.pictureURL} alt="" />
                        ) : branding.exhibitorsPageContent.defaultLogoVisibleOnCompanyTiles ? (
                            <CompanyLogo src={"/branding/rsz_defaultgrey.png"} />
                        ) : (
                            <h2 style={{ fontFamily: branding.font1 }}>{props.initials}</h2>
                        )}
                    </CompanyLogoDiv>
                </Col>
                <Col xs={useMobileDesign ? 9 : 10}>
                    {props.type === "news" && props.order.includes(InfoContentOrderType.NEWS_DATE) && props.newsDate && (
                        <NewsDate>{getNewsDateFormatted(props.newsDate, languageState.getLanguage())}</NewsDate>
                    )}
                    <Col>
                        <Row>
                            <Col className="p-0" xs={10}>
                                <h3 style={{ fontSize: useMobileDesign ? "16px" : "22px", fontWeight: 800 }}>{props.name}</h3>
                            </Col>
                            <Col className="d-flex justify-content-end p-0 text-right" xs={2}>
                                {props.type === "joboffer" && props.showRecommendModal && (
                                    <ShareIcon
                                        onClick={(e) => {
                                            e.preventDefault()
                                            e.stopPropagation()
                                            if (props.showRecommendModal)
                                                props.showRecommendModal(
                                                    ShareTargetType.JOBOFFER,
                                                    props.id,
                                                    buildDetailLink(props.id, props.name!, "joboffer")
                                                )
                                        }}
                                    >
                                        {IconShare({ fill: branding.sideIconBar.sideIconColorDark })}
                                    </ShareIcon>
                                )}
                                <BookmarkWithToggle
                                    newBookmarkItem={true}
                                    fontSize={"25px"}
                                    color={branding.sideIconBar.sideIconColorDark}
                                    favIconBasic={true}
                                    type={props.type}
                                    id={props.id}
                                    name={props.name as string}
                                />
                            </Col>
                        </Row>
                    </Col>

                    {props.order.map((item, index) => {
                        if (item === InfoContentOrderType.COMPANY_DETAILS && company) {
                            return <CompanyDetailInfo company={company} />
                        } else if (item === InfoContentOrderType.JOBOFFER_DETAILS && joboffer) {
                            return <JobOfferDetails joboffer={joboffer} />
                        } else if (item === InfoContentOrderType.BADGES) {
                            if (props.type === "organization") {
                                return (
                                    <div style={{ marginBottom: "-20px" }}>
                                        <BadgeArea
                                            categories={getSimpleCategories(props.categories || [], props.showCategoryHierarchy)}
                                            marginTop="30px"
                                        />
                                    </div>
                                )
                            } else {
                                return (
                                    <BadgeArea
                                        categories={getSimpleCategories(props.categories || [], props.showCategoryHierarchy)}
                                        marginTop="20px"
                                    />
                                )
                            }
                        } else if (item === InfoContentOrderType.SOCIAL_MEDIA && props.socialMedias?.length) {
                            return <CompanySocialMedia key={index} socialMedias={props.socialMedias} />
                        }

                        if (
                            props.type === "news" &&
                            item === InfoContentOrderType.NEWS_SUBHEADLINE &&
                            props.description?.teaser
                        ) {
                            return (
                                <DesktopVersionContainer>
                                    <NewsSubheadline key={index} className="mt-3">
                                        {props.description?.teaser.split("\\n").map((item, i) => (
                                            <span key={i}>
                                                {item}
                                                <br />
                                            </span>
                                        ))}
                                    </NewsSubheadline>
                                </DesktopVersionContainer>
                            )
                        } else if (
                            props.type !== "news" &&
                            props.type !== "joboffer" &&
                            item === InfoContentOrderType.DESCRIPTION &&
                            props.description?.text
                        ) {
                            return (
                                <CompanyTeaser key={index} className="mt-3">
                                    {props.description?.text.split("\\n").map((item, i) => (
                                        <span key={i}>
                                            {item}
                                            <br />
                                        </span>
                                    ))}
                                </CompanyTeaser>
                            )
                        } else if (
                            item === InfoContentOrderType.HALLE_STAND_INFO &&
                            props.company &&
                            props.company.stands &&
                            props.company.stands.length
                        ) {
                            return (
                                <HalleStandSection
                                    key={index}
                                    hasSocials={
                                        props.company?.socialMedias! && props.company?.socialMedias!.length > 0 ? true : false
                                    }
                                >
                                    <HeaderTitle className="mb-3 mt-0">
                                        {strings.organizationDetailPageContent.halleStandSectionTitle}
                                    </HeaderTitle>
                                    {props.company.stands.map((stand, idx) => {
                                        return (
                                            <HalleStandSingle
                                                onClick={() => {
                                                    if (!branding.organizationDetailPageContent.halleStandLinkEnabled) return

                                                    history.push(buildHallplanLink(stand.hallNr, stand.standNr))
                                                }}
                                                key={idx}
                                            >
                                                {stand.standName}
                                            </HalleStandSingle>
                                        )
                                    })}
                                </HalleStandSection>
                            )
                        } else if (
                            item === InfoContentOrderType.TALK_WITH_TEAM &&
                            (isExplorationOrPostEventPhase || isLivePhase) &&
                            !branding.organizationDetailPageContent.removeExpoShowroomDuringPostEvent &&
                            company &&
                            config.expoShowroomEnabled &&
                            hasAvailableStaff(company)
                        ) {
                            return (
                                <DesktopVersionContainer key={index}>
                                    <TalkWithTeamDiv key={index}>
                                        <Col xs={1}>
                                            {IconCameraJoin({
                                                width: "30",
                                                height: "30",
                                                fill: branding.sideIconBar.sideIconColorDark
                                            })}
                                        </Col>
                                        <Col
                                            style={{ fontSize: "16px", fontWeight: 500 }}
                                            xs={strings.organizationDetailPageContent.joinButton.length > 14 ? 8 : 9}
                                        >
                                            {strings.organizationDetailPageContent.talkWithTeamBefString} {company.name}{" "}
                                            {strings.organizationDetailPageContent.talkWithTeamAftString}
                                        </Col>
                                        <JoinButtonCol
                                            xs={strings.organizationDetailPageContent.joinButton.length > 14 ? 3 : 2}
                                            onClick={() =>
                                                showPrivacyPolicyModal(company, (accepted) => {
                                                    joinShowroom(company, loggedInUser!, chime, meeting)
                                                })
                                            }
                                            disabled={
                                                !hasAvailableStaff(company) ||
                                                (isExplorationOrPostEventPhase && !(getIamPartOf(queryParams) === "onboarding"))
                                            }
                                        >
                                            <p
                                                className="user-select-none"
                                                style={{
                                                    fontSize:
                                                        strings.organizationDetailPageContent.joinButton.length > 14
                                                            ? "12px"
                                                            : "14px",
                                                    marginBottom: "0px"
                                                }}
                                            >
                                                {strings.organizationDetailPageContent.joinButton}
                                            </p>
                                        </JoinButtonCol>
                                        {isExplorationOrPostEventPhase && (
                                            <ExplorationPhaseMessage className="mt-2">
                                                {isExplorationPhase
                                                    ? strings.organizationDetailPageContent.explorationPhasePlaceholder
                                                    : strings.organizationDetailPageContent.postPhasePlaceholder}
                                            </ExplorationPhaseMessage>
                                        )}
                                    </TalkWithTeamDiv>
                                </DesktopVersionContainer>
                            )
                        } else if (
                            item === InfoContentOrderType.CONFERENCE_ROOMS &&
                            company?.conferenceRooms &&
                            company?.conferenceRooms.length > 0
                        ) {
                            return (
                                <DesktopVersionContainer key={index}>
                                    <RowTileParent key={index} style={{ marginLeft: "-180px" }}>
                                        <TileRow
                                            title={strings.organizationDetailPageContent.virtualCafesTitle}
                                            height="220px"
                                            offsetLeft={props.containerOffsetLeft}
                                            scrollBar
                                            childWidth={510}
                                            tileRowMargin="50px 0"
                                            childCount={company.conferenceRooms.length}
                                        >
                                            {company.conferenceRooms.map((conferenceRoom) => {
                                                return (
                                                    <MeetingRoomGroupContainer key={conferenceRoom.id}>
                                                        <MeetingRoomGroup
                                                            key={conferenceRoom.id}
                                                            source={undefined}
                                                            meetingRoomGroupConfig={conferenceRoom}
                                                            roomType="conferenceroom"
                                                            rerenderOnUnlockedChanged={userAccessState.isUnlocked(conferenceRoom)}
                                                            companyStaff={company.allPersons}
                                                        />
                                                    </MeetingRoomGroupContainer>
                                                )
                                            })}
                                        </TileRow>
                                    </RowTileParent>
                                </DesktopVersionContainer>
                            )
                        } else return null
                    })}
                </Col>
                {props.type === "news" && props.order.includes(InfoContentOrderType.DESCRIPTION) && props.description?.text && (
                    <Col xs={12}>
                        {props.description?.teaser && (
                            <MobileVersionContainer>
                                <NewsSubheadline className="mt-3">
                                    {props.description?.teaser?.split("\\n").map((item, i) => (
                                        <span key={i}>
                                            {item}
                                            <br />
                                        </span>
                                    ))}
                                </NewsSubheadline>
                            </MobileVersionContainer>
                        )}

                        <MobileVersionContainer>
                            <CompanyTeaser className="mt-3 news">
                                {props.description?.text?.split("\\n").map((item, i) => (
                                    <span key={i}>
                                        {item}
                                        <br />
                                    </span>
                                ))}
                            </CompanyTeaser>
                        </MobileVersionContainer>

                        <DesktopVersionContainer>
                            <Row className="m-0">
                                <Col xs={props.persons && props.persons?.length! > 0 ? 8 : 11} className="p-0">
                                    <CompanyTeaser className="mt-3 news">
                                        {props.description?.text?.split("\\n").map((item, i) => (
                                            <span key={i}>
                                                {item}
                                                <br />
                                            </span>
                                        ))}
                                    </CompanyTeaser>
                                </Col>

                                <Col xs={4} className="p-0">
                                    {props.persons && props.persons?.length! > 0 && (
                                        <Persons
                                            persons={props.persons || []}
                                            setShowRecommendOrganizationModal={setShowRecommendOrganizationModal}
                                            setLink={setLink}
                                            setTargetId={setTargetId}
                                            setType={setType}
                                            descriptionExists={props.description?.text !== undefined}
                                            newsPage
                                        />
                                    )}
                                </Col>
                            </Row>
                        </DesktopVersionContainer>
                    </Col>
                )}
                <PrivacyModal />
            </InfoRow>

            {showRecommendOrganizationModal && (
                <RecommendModal
                    targetId={targetId}
                    type={type as ShareTargetType}
                    link={`https://${window.location.hostname}` + link}
                    sotUser={[]}
                    close={() => setShowRecommendOrganizationModal(false)}
                ></RecommendModal>
            )}
            <PrivacyModal />
        </MobileSectionWrapper>
    )

    return (
        <>
            <ConditionalWrapper
                wrapper={(children) => (props.type !== "news" ? <DesktopVersionContainer children={children} /> : null)}
            >
                {DesktopInfo}
            </ConditionalWrapper>

            {props.type === "news" && props.persons && props.persons?.length! > 0 && (
                <MobileVersionContainer>
                    <MobileSectionWrapper>
                        <Col xs={11} className="p-0">
                            <Persons
                                persons={props.persons || []}
                                setShowRecommendOrganizationModal={setShowRecommendOrganizationModal}
                                setLink={setLink}
                                setTargetId={setTargetId}
                                setType={setType}
                                descriptionExists={props.description?.text !== undefined}
                                newsPage
                            />
                        </Col>
                    </MobileSectionWrapper>
                </MobileVersionContainer>
            )}

            {props.type !== "news" && props.type !== "joboffer" && company && (
                <MobileVersionContainer>
                    <MobileSectionWrapper>
                        <Row>
                            <MobileCompanyInfo company={company} socialMedias={props.socialMedias} />
                        </Row>
                    </MobileSectionWrapper>
                </MobileVersionContainer>
            )}
        </>
    )
}

const CompanyInfoIconContainer = styled.div`
    padding-right: 15px;
`
const ShowMoreDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 15px;
    /* padding-right: 40px; */
`

const ShowMoreBtn = styled.div`
    cursor: pointer;
    font-family: ${branding.font1};
    font-size: 12px;
    line-height: 17px;
`

const MobileCompanyInfo: React.FunctionComponent<{ company?: Company; socialMedias?: SocialMedia[] }> = (props) => {
    const strings = useLanguageState().getStrings()
    const lang = useLanguageState().getLanguage()
    const [showMore, setShowMore] = useState(false)
    const [showMoreBtnClicked, setShowMoreBtnClicked] = useState(false)
    const history = useHistory()

    useEffect(() => {
        if (props.company && props.company?.stands!) props.company?.stands!.length > 3 ? setShowMore(true) : setShowMore(false)
        else setShowMore(false)
        // eslint-disable-next-line
    }, [props.company?.stands])

    useEffect(() => {
        setShowMoreBtnClicked(false)
    }, [lang])

    const componentDecorator = (href: string, text: string, key: number) => (
        <a
            style={{ fontWeight: "bold", color: branding.mainInfoColor }}
            href={href}
            key={key}
            target="_blank"
            rel="noopener noreferrer"
        >
            {text}
        </a>
    )

    return (
        <CompanyAdditionalInfoRoot>
            <DetailsAdditionalInfoDiv style={{ flex: 1, display: "flex", flexDirection: "row", marginRight: "50px" }}>
                <CompanyInfoIconContainer>
                    {(props.company?.name || props.company?.adress1 || props.company?.postCode || props.company?.country) &&
                        IconLocation({ fill: branding.sideIconBar.sideIconColorDark, width: "17", height: "17" })}
                </CompanyInfoIconContainer>
                <div>
                    <p>{props.company?.name}</p>
                    {props.company?.adress1 && <p>{props.company?.adress1}</p>}
                    {props.company?.adress2 && <p>{props.company?.adress2}</p>}
                    {props.company?.adress3 && <p>{props.company?.adress3}</p>}
                    <p>
                        {props.company?.postCode} {props.company?.city}
                    </p>
                    <p>{props.company?.country}</p>
                </div>
            </DetailsAdditionalInfoDiv>

            {props.company?.phone && !branding.organizationDetailPageContent.hideTelephone && (
                <DetailsAdditionalInfoDiv style={{ flex: 1, display: "flex", flexDirection: "row", marginRight: "50px" }}>
                    <CompanyInfoIconContainer>
                        {IconPhone({ fill: branding.sideIconBar.sideIconColorDark, width: "17", height: "17" })}
                    </CompanyInfoIconContainer>
                    <div>{<p>{props.company?.phone}</p>}</div>
                </DetailsAdditionalInfoDiv>
            )}

            {props.company?.email && !branding.organizationDetailPageContent.hideEmailAddress && (
                <DetailsAdditionalInfoDiv style={{ flex: 1, display: "flex", flexDirection: "row" }}>
                    <CompanyInfoIconContainer>
                        {IconEmail({ fill: branding.sideIconBar.sideIconColorDark, width: "17", height: "17" })}
                    </CompanyInfoIconContainer>
                    <p>
                        <Linkify componentDecorator={componentDecorator}>{props.company?.email}</Linkify>
                    </p>
                </DetailsAdditionalInfoDiv>
            )}

            {props.company?.web && (
                <DetailsAdditionalInfoDiv style={{ flex: 1, display: "flex", flexDirection: "row" }}>
                    <CompanyInfoIconContainer>
                        {IconLink({ fill: branding.sideIconBar.sideIconColorDark, width: "17", height: "17" })}
                    </CompanyInfoIconContainer>
                    <p>
                        <Linkify componentDecorator={componentDecorator}>{props.company?.web}</Linkify>
                    </p>
                </DetailsAdditionalInfoDiv>
            )}

            {props.company && props.company?.stands && props.company?.stands.length && (
                <div>
                    <DetailsAdditionalInfoDiv style={{ flex: 1, display: "flex", flexDirection: "row" }}>
                        <CompanyInfoIconContainer>
                            {IconHallplan({ fill: branding.sideIconBar.sideIconColorDark, width: "17", height: "17" })}
                        </CompanyInfoIconContainer>
                        <HalleStandSectionMobileView>
                            <p>{strings.organizationDetailPageContent.halleStandSectionTitle}</p>
                            {props.company?.stands
                                .slice(0, showMoreBtnClicked ? props.company?.stands.length : 3)
                                .map((stand, idx) => {
                                    return (
                                        <HalleStandSingleMobileView
                                            onClick={() => {
                                                if (!branding.organizationDetailPageContent.halleStandLinkEnabled) return

                                                history.push(buildHallplanLink(stand.hallNr, stand.standNr))
                                            }}
                                            key={idx}
                                        >
                                            {stand.standName}
                                        </HalleStandSingleMobileView>
                                    )
                                })}
                            {props.company?.stands.length > 3 && showMore && (
                                <ShowMoreDiv>
                                    <ShowMoreBtn onClick={() => setShowMoreBtnClicked(!showMoreBtnClicked)}>
                                        {showMoreBtnClicked
                                            ? strings.productDetailPageContent.showLessText
                                            : strings.productDetailPageContent.showMoreText}
                                    </ShowMoreBtn>
                                    <div style={{ marginLeft: "7px", marginBottom: "2px" }}>
                                        {showMoreBtnClicked
                                            ? IconShowLess({
                                                  fill: branding.sideIconBar.sideIconColorDark,
                                                  width: "12",
                                                  height: "12"
                                              })
                                            : IconShowMore({
                                                  fill: branding.sideIconBar.sideIconColorDark,
                                                  width: "12",
                                                  height: "12"
                                              })}
                                    </div>
                                </ShowMoreDiv>
                            )}
                        </HalleStandSectionMobileView>
                    </DetailsAdditionalInfoDiv>
                </div>
            )}

            {props.company?.description?.text && (
                <DetailsAdditionalInfoDiv style={{ marginTop: "20px", marginBottom: "20px" }}>
                    <CompanyInfoParagraph lang={lang} style={{ marginBottom: "5px" }}>
                        {strings.organizationDetailPageContent.descriptionLabel}
                    </CompanyInfoParagraph>
                    <p style={{ marginRight: "85px" }}>
                        {props.company?.description?.text.split("\\n").map((item, i) => (
                            <span key={i}>
                                {item}
                                <br />
                            </span>
                        ))}
                    </p>
                </DetailsAdditionalInfoDiv>
            )}

            {props.company?.foundingYear && (
                <DetailsAdditionalInfoDiv style={{ flex: 1, display: "flex", flexDirection: "row" }}>
                    <CompanyInfoParagraph lang={lang}>
                        {strings.organizationDetailPageContent.foundingYearTitle}:
                    </CompanyInfoParagraph>

                    <p>{props.company?.foundingYear}</p>
                </DetailsAdditionalInfoDiv>
            )}

            {props.company?.size && (
                <DetailsAdditionalInfoDiv style={{ flex: 1, display: "flex", flexDirection: "row" }}>
                    <CompanyInfoParagraph lang={lang}>
                        {strings.organizationDetailPageContent.companySizeTitle}:
                    </CompanyInfoParagraph>

                    <p>{props.company?.size}</p>
                </DetailsAdditionalInfoDiv>
            )}

            {props.company?.industry && (
                <DetailsAdditionalInfoDiv style={{ flex: 1, display: "flex", flexDirection: "row", marginRight: "30px" }}>
                    <CompanyInfoParagraph lang={lang}>
                        {strings.organizationDetailPageContent.industryTitle}:
                    </CompanyInfoParagraph>

                    <p>{props.company?.industry}</p>
                </DetailsAdditionalInfoDiv>
            )}
            {props.socialMedias && <CompanySocialMedia socialMedias={props.socialMedias} />}
        </CompanyAdditionalInfoRoot>
    )
}
/* #endregion */

/* #region  Company social media */

const SocialMediaIcon = styled.div`
    cursor: pointer;

    a {
        color: unset;
        text-decoration: none;
    }
`
const SocialMediaContainer = styled.div`
    display: flex;
    margin-top: 5px;
    margin-bottom: 0;

    @media ${device.tablet} {
        margin-top: 2rem !important;
        margin-bottom: 2rem !important;
    }
`
interface CompanySocialMediaProps {
    socialMedias: SocialMedia[]
}

const CompanySocialMedia: React.FunctionComponent<CompanySocialMediaProps> = (props) => {
    const strings = useLanguageState().getStrings()

    const facebook: SocialMedia | undefined = props.socialMedias.find(
        (socialMedia: SocialMedia) => socialMedia.type === SocialMediaType.FACEBOOK
    )
    const twitter: SocialMedia | undefined = props.socialMedias.find(
        (socialMedia: SocialMedia) => socialMedia.type === SocialMediaType.TWITTER
    )
    const instagram: SocialMedia | undefined = props.socialMedias.find(
        (socialMedia: SocialMedia) => socialMedia.type === SocialMediaType.INSTAGRAM
    )
    const youTube: SocialMedia | undefined = props.socialMedias.find(
        (socialMedia: SocialMedia) => socialMedia.type === SocialMediaType.YOUTUBE
    )
    const linkedIn: SocialMedia | undefined = props.socialMedias.find(
        (socialMedia: SocialMedia) => socialMedia.type === SocialMediaType.LINKEDIN
    )
    const xing: SocialMedia | undefined = props.socialMedias.find(
        (socialMedia: SocialMedia) => socialMedia.type === SocialMediaType.XING
    )
    const pinterest: SocialMedia | undefined = props.socialMedias.find(
        (socialMedia: SocialMedia) => socialMedia.type === SocialMediaType.PINTEREST
    )

    function checkIfValid(socialMedia: SocialMedia | undefined) {
        return socialMedia && socialMedia !== null && socialMedia?.link?.length! > 0
    }

    function handleLinkClick(link: string, e: React.MouseEvent<HTMLAnchorElement>) {
        if (!link) e.currentTarget.removeAttribute("href")
    }

    if (
        !checkIfValid(facebook) &&
        !checkIfValid(twitter) &&
        !checkIfValid(instagram) &&
        !checkIfValid(youTube) &&
        !checkIfValid(linkedIn) &&
        !checkIfValid(xing) &&
        !checkIfValid(pinterest)
    )
        return <></>

    return (
        <DetailsAdditionalInfoDiv style={{ marginTop: "50px" }}>
            <HeaderTitle className="mb-3 mt-0">{strings.myProfilePageContent.socialMediaSectionTitle}</HeaderTitle>
            <SocialMediaContainer>
                {branding.organizationDetailPageContent.availableSocialMedias.map((item, index) => {
                    if (item === SocialMediaType.FACEBOOK) {
                        return (
                            <React.Fragment key={index}>
                                {facebook && facebook.link && facebook.link.length > 0 && (
                                    <SocialMediaIcon className="mr-3">
                                        <a
                                            href={getProperUrl(facebook.link)}
                                            onClick={(e) => handleLinkClick(facebook.link, e)}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {branding.socialMediaIcons.useOriginalSocialMediaIcons
                                                ? IconFacebookOriginal({ width: "20", height: "20" })
                                                : IconFacebook({
                                                      fill: branding.sideIconBar.sideIconColorDark,
                                                      width: "20",
                                                      height: "20"
                                                  })}
                                        </a>
                                    </SocialMediaIcon>
                                )}
                            </React.Fragment>
                        )
                    }

                    if (item === SocialMediaType.TWITTER) {
                        return (
                            <React.Fragment key={index}>
                                {twitter && twitter.link && twitter.link.length > 0 && (
                                    <SocialMediaIcon className="mr-3">
                                        <a
                                            href={getProperUrl(twitter.link)}
                                            onClick={(e) => handleLinkClick(twitter.link, e)}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {branding.socialMediaIcons.useOriginalSocialMediaIcons
                                                ? IconTwitter({ width: "20", height: "20" })
                                                : IconTwitter({
                                                      fill: branding.sideIconBar.sideIconColorDark,
                                                      width: "20",
                                                      height: "20"
                                                  })}
                                        </a>
                                    </SocialMediaIcon>
                                )}
                            </React.Fragment>
                        )
                    }

                    if (item === SocialMediaType.LINKEDIN) {
                        return (
                            <React.Fragment key={index}>
                                {linkedIn && linkedIn.link && linkedIn.link.length > 0 && (
                                    <SocialMediaIcon className="mr-3">
                                        <a
                                            href={getProperUrl(linkedIn.link)}
                                            onClick={(e) => handleLinkClick(linkedIn.link, e)}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {branding.socialMediaIcons.useOriginalSocialMediaIcons
                                                ? IconLinkedInOriginal({ width: "20", height: "20" })
                                                : IconLinkedIn({
                                                      fill: branding.sideIconBar.sideIconColorDark,
                                                      width: "20",
                                                      height: "20"
                                                  })}
                                        </a>
                                    </SocialMediaIcon>
                                )}
                            </React.Fragment>
                        )
                    }

                    if (item === SocialMediaType.XING) {
                        return (
                            <React.Fragment key={index}>
                                {xing && xing.link && xing.link.length > 0 && (
                                    <SocialMediaIcon className="mr-3">
                                        <a
                                            href={getProperUrl(xing.link)}
                                            onClick={(e) => handleLinkClick(xing.link, e)}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {branding.socialMediaIcons.useOriginalSocialMediaIcons
                                                ? IconXingOriginal({ width: "20", height: "20" })
                                                : IconXing({
                                                      fill: branding.sideIconBar.sideIconColorDark,
                                                      width: "20",
                                                      height: "20"
                                                  })}
                                        </a>
                                    </SocialMediaIcon>
                                )}
                            </React.Fragment>
                        )
                    }

                    if (item === SocialMediaType.INSTAGRAM) {
                        return (
                            <React.Fragment key={index}>
                                {instagram && instagram.link && instagram.link.length > 0 && (
                                    <SocialMediaIcon className="mr-3">
                                        <a
                                            href={getProperUrl(instagram.link)}
                                            onClick={(e) => handleLinkClick(instagram.link, e)}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {branding.socialMediaIcons.useOriginalSocialMediaIcons
                                                ? IconInstagramOriginal({ width: "20", height: "20" })
                                                : IconInstagram({
                                                      fill: branding.sideIconBar.sideIconColorDark,
                                                      width: "20",
                                                      height: "20"
                                                  })}
                                        </a>
                                    </SocialMediaIcon>
                                )}
                            </React.Fragment>
                        )
                    }

                    if (item === SocialMediaType.YOUTUBE) {
                        return (
                            <React.Fragment key={index}>
                                {youTube && youTube.link && youTube.link.length > 0 && (
                                    <SocialMediaIcon className="mr-3">
                                        <a
                                            href={getProperUrl(youTube.link)}
                                            onClick={(e) => handleLinkClick(youTube.link, e)}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {branding.socialMediaIcons.useOriginalSocialMediaIcons
                                                ? IconYouTubeOriginal({ width: "20", height: "20" })
                                                : IconYouTube({
                                                      fill: branding.sideIconBar.sideIconColorDark,
                                                      width: "20",
                                                      height: "20"
                                                  })}
                                        </a>
                                    </SocialMediaIcon>
                                )}
                            </React.Fragment>
                        )
                    }

                    if (item === SocialMediaType.PINTEREST) {
                        return (
                            <React.Fragment key={index}>
                                {pinterest && pinterest.link && pinterest.link.length > 0 && (
                                    <SocialMediaIcon className="mr-3">
                                        <a
                                            href={getProperUrl(pinterest.link)}
                                            onClick={(e) => handleLinkClick(pinterest.link, e)}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {branding.socialMediaIcons.useOriginalSocialMediaIcons
                                                ? IconPinterestOrginal({ width: "20", height: "20" })
                                                : IconPinterest({
                                                      fill: branding.sideIconBar.sideIconColorDark,
                                                      width: "20",
                                                      height: "20"
                                                  })}
                                        </a>
                                    </SocialMediaIcon>
                                )}
                            </React.Fragment>
                        )
                    }

                    return null
                })}
            </SocialMediaContainer>
        </DetailsAdditionalInfoDiv>
    )
}

/* #endregion */

/* #region  Founding year, size, industry*/
const CompanyDetailsRoot = styled.div`
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    flex: 1;
    line-height: 17px;
    font-size: 12px;
    font-weight: 400;
    font-style: normal;
    font-family: ${branding.font1};
    margin-bottom: 2rem !important;
`
const CompanyAdditionalInfoRoot = styled.div`
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    flex: 1;
    line-height: 17px;
    font-size: 12px;
    font-weight: 400;
    font-style: normal;
    font-family: ${branding.font1};

    & p {
        margin-bottom: 0;
    }

    @media ${device.mobile} {
        margin-left: 25px;
        padding: 10px 0;
    }
`

const DetailsAdditionalInfoDiv = styled.div`
    line-height: 17px;
    font-size: 12px;
    font-weight: 400;
    font-style: normal;
    font-family: ${branding.font1};

    & p {
        margin-bottom: 0;
    }

    & a {
        font-weight: normal !important;
    }

    @media ${device.mobile} {
        margin-bottom: 20px;
        font-size: 14px;
        line-height: 24px;
    }
`

interface CompanyDetailInfoProps {
    company: Company
}
const CompanyDetailInfo: React.FunctionComponent<CompanyDetailInfoProps> = (props) => {
    const strings = useLanguageState().getStrings()
    const company = props.company
    return (
        <CompanyDetailsRoot className="mt-3">
            <CompanyAddressPhoneEmail company={company} />
            <CompanyAdditionalInfoRoot>
                <DetailsAdditionalInfoDiv style={{ flex: 1, display: "flex", flexDirection: "row" }}>
                    <div style={{ paddingRight: "10px" }}>
                        {(company.foundingYear || company.size || company.industry) &&
                            IconInfo({ fill: branding.sideIconBar.sideIconColorDark, width: "20", height: "20" })}
                    </div>
                    <div>
                        {company.foundingYear && (
                            <p>
                                {strings.organizationDetailPageContent.foundingYearTitle}: {company.foundingYear}
                            </p>
                        )}
                        {company.size && (
                            <p>
                                {strings.organizationDetailPageContent.companySizeTitle}: {company.size}
                            </p>
                        )}
                        {company.industry && (
                            <p>
                                {strings.organizationDetailPageContent.industryTitle}: {company.industry}
                            </p>
                        )}
                    </div>
                </DetailsAdditionalInfoDiv>
            </CompanyAdditionalInfoRoot>
        </CompanyDetailsRoot>
    )
}

/* #endregion */

/* #region  Team and session template component */
interface ScrollableDivProps {
    width: string
}
export const ScrollableDiv = styled.div<ScrollableDivProps>`
    max-height: 350px;
    width: ${(props) => props.width};
    padding: 0;
    overflow-y: auto;
    overflow-x: hidden;
    -ms-overflow-style: none;
    scrollbar-width: none;
    ::-webkit-scrollbar {
        display: none;
    }
`
const SessionsContentCol = styled(Col)`
    border-bottom: ${branding.mainBorder ? branding.mainBorder : "1px solid #d9d9d9"};
    padding: 25px 0;
`

const ScrollerShadowTop = styled.div`
    position: absolute;
    width: 100%;
    height: 10%;
    background: transparent;
    background: ${branding.primaryScrollWhiteShadowTTB};
    left: 0;
    top: 0;
    z-index: 2;
`

const ScrollerShadowBottom = styled.div`
    position: absolute;
    width: 100%;
    height: 10%;
    background: transparent;
    background: ${branding.primaryScrollWhiteShadowTTB};
    left: 0;
    bottom: 0;
    z-index: 2;
    transform: rotate(180deg);
`

const ViewAllButtonContainer = styled.div`
    cursor: pointer;
    margin-top: 3px;
    position: relative;
    z-index: 10;
`

const ViewAllButtonText = styled.div`
    display: inline-block;
    font-family: ${branding.font1};
    font-size: 12px;
    line-height: 16px;
`

const ViewAllButtonIcon = styled.div`
    display: inline-block;
    margin-left: 5px;
`

const TeamRow = styled(Row)`
    margin-left: 10px;
    margin-right: 12px;

    @media ${device.tablet} {
        margin-left: 5px;
        margin-right: 5px;
    }
`

interface TeamSessionsTemplateProps {
    team?: Person[]
    sessions?: EventDate[]
    coupons?: any[]
    type: "team" | "session" | "coupon"
    organizationId: string
    organizationName?: string
    organization: Company
    onAccessDenied?: () => void
    past?: boolean
    live?: boolean
    hideShadows?: boolean
    containerOffsetLeft?: number
}

interface ViewAllButtonProps {
    viewAll: boolean
    setViewAll: (value: boolean) => void
}

export const ViewAllButton: React.FunctionComponent<ViewAllButtonProps> = (props: ViewAllButtonProps) => {
    const strings = useLanguageState().getStrings()

    return (
        <MobileVersionContainer>
            <ViewAllButtonContainer onClick={() => props.setViewAll(!props.viewAll)}>
                <ViewAllButtonText>
                    {props.viewAll
                        ? strings.organizationDetailPageContent.viewLessButtonText
                        : strings.organizationDetailPageContent.viewAllButtonText}
                </ViewAllButtonText>
                <ViewAllButtonIcon>
                    {props.viewAll
                        ? IconArrowUpLangSwitcher({ fill: branding.sideIconBar.sideIconColorDark })
                        : IconArrowDownLangSwitcher({ fill: branding.sideIconBar.sideIconColorDark })}
                </ViewAllButtonIcon>
            </ViewAllButtonContainer>
        </MobileVersionContainer>
    )
}

const CustomDesktopVersionContainer = styled.div`
    display: none;
    width: 100%;

    @media ${device.tablet} {
        display: block;
    }
`

const TeamSessionsTemplate: React.FunctionComponent<TeamSessionsTemplateProps> = (props) => {
    const strings = useLanguageState().getStrings()
    const scrollRef = useRef<HTMLDivElement>(null)
    const [position, setPosition] = useState(0)
    const [value, setValue] = useState(0)
    const maxScrollRange = scrollRef.current?.scrollHeight! - scrollRef.current?.clientHeight!
    const width = maxScrollRange !== 0 ? "95%" : "100%"
    const [staff, setStaff] = useState<Staff[] | undefined>()
    const userState = useLoggedInState()
    const profileId = userState.user()?.profileId
    const { showPrivacyPolicyModal, PrivacyModal } = usePrivacyPolicyModal()
    // Are shadows active
    const [isShadowTop, setIsShadowTop] = useState<boolean>(false)
    const [isShadowBottom, setIsShadowBottom] = useState<boolean>(false)

    const [viewAll, setViewAll] = useState<boolean>((props.team && props.team?.length! <= 3) ?? false)

    let sessions = props.sessions
    const location = useLocation()
    let currentLocation = location.pathname
    let coupons = props.coupons

    useEffect(() => {
        setViewAll((props.team && props.team?.length! <= 3) ?? false)
    }, [props.team])

    useEffect(() => {
        scrollRef.current?.scrollTo(0, position)
    }, [position])

    // DETERMING IF THE SHADOWS SHOULD BE VISIBLE
    useEffect(() => {
        if (scrollRef.current!.scrollWidth === scrollRef.current!.clientHeight || props.hideShadows) return
        value === 0 ? setIsShadowTop(false) : setIsShadowTop(true)
        maxScrollRange - value < 40 ? setIsShadowBottom(false) : setIsShadowBottom(true)
        // eslint-disable-next-line
    }, [value, maxScrollRange])

    useEffect(() => {
        setStaff(
            props.team
                ?.filter((person) => person.visible)
                .map((person) => {
                    return {
                        firstName: person.firstName,
                        lastName: person.lastName,
                        id: person.id,
                        type: StaffType.PERSON,
                        logoUrl: person.logoUrl || person.userLogoUrl,
                        position: person.position,
                        company: person.organization,
                        sotUserId: person.userId,
                        visible: person.visible,
                        showroomStandby: person.showroomStandby,
                        title: person.title,
                        categories: person.categories
                    }
                })
        )
    }, [props.organizationId]) //eslint-disable-line

    if (
        (props.type === "team" && (!props.team || props.team.length === 0)) ||
        (props.type === "session" && (!props.sessions || props.sessions.length === 0))
    )
        return null

    const staffLength = staff !== undefined ? staff.length : 0
    let headerTitle =
        props.type === "team"
            ? (branding.organizationDetailPageContent.teamSectionTitleVisible
                  ? strings.organizationDetailPageContent.teamSectionTitle
                  : props.organizationName) +
              " (" +
              staffLength +
              ")"
            : props.type === "session"
            ? strings.organizationDetailPageContent.upcomingSessionsTitle + " (" + props.sessions!.length + ")"
            : strings.sideIconBar.goodiebagMenuText

    if (props.live) headerTitle = strings.organizationDetailPageContent.liveSessionsTitle + " (" + props.sessions!.length + ")"

    if (props.past) {
        headerTitle =
            props.type === "team"
                ? props.organizationName + " (" + staffLength + ")"
                : strings.organizationDetailPageContent.pastSessionsTitle + " (" + props.sessions!.length + ")"
    }

    return (
        <Col xs={12}>
            <TeamRow>
                <Col xs={12} className="p-0 mb-4" style={{ display: "flex", justifyContent: "space-between" }}>
                    <HeaderTitle>{headerTitle}</HeaderTitle>
                    {props.team && props.team?.length! > 3 && <ViewAllButton viewAll={viewAll} setViewAll={setViewAll} />}
                </Col>
                <CustomDesktopVersionContainer>
                    <div style={{ width: "100%", position: "relative" }}>
                        <ScrollableDiv ref={scrollRef} onScroll={() => setValue(scrollRef.current?.scrollTop!)} width={width}>
                            {staff &&
                                staff.map((person, index) => {
                                    return (
                                        <StaffEntry
                                            onAccessDenied={() => {
                                                if (props.onAccessDenied) {
                                                    props.onAccessDenied()
                                                }
                                            }}
                                            key={index}
                                            staff={person}
                                            organizationId={props.organizationId}
                                            backOffice={false}
                                        />
                                    )
                                })}

                            {sessions &&
                                sessions.map((session) => {
                                    return (
                                        <SessionsContentCol xs={12} key={session.id}>
                                            <SessionData session={session} />
                                        </SessionsContentCol>
                                    )
                                })}
                            {coupons &&
                                coupons.map((coupon) => {
                                    return (
                                        <CouponData
                                            key={coupon.id}
                                            companyId={props.organizationId}
                                            {...coupon}
                                            onAction={() => {
                                                showPrivacyPolicyModal(props.organization, (accepted) => {
                                                    if (coupon.url !== null && !coupon.url?.includes(currentLocation)) {
                                                        window.open(coupon.url, "_blank")
                                                        trackVisit(profileId!, props.organizationId, "COUPON", coupon.title)
                                                    }
                                                })
                                            }}
                                        />
                                    )
                                })}
                            {isShadowTop && !props.hideShadows && <ScrollerShadowTop />}
                            {isShadowBottom && !props.hideShadows && <ScrollerShadowBottom />}
                        </ScrollableDiv>
                    </div>
                    <ScrollBarComponent
                        value={value}
                        maxScrollRange={maxScrollRange ? maxScrollRange : 0}
                        onScroll={(val: number) => {
                            setPosition(val)
                            setValue(val)
                        }}
                        isVertical={true}
                    ></ScrollBarComponent>
                </CustomDesktopVersionContainer>

                <MobileVersionContainer style={{ width: "100%" }}>
                    {viewAll ? (
                        <Row style={{ marginRight: 0 }}>
                            {staff && (
                                <>
                                    {staff.map((person, index) => {
                                        return (
                                            <Col xs={4} key={index}>
                                                <div
                                                    style={{
                                                        width: 95,
                                                        height: 95,
                                                        marginBottom: 10,
                                                        overflow: "hidden",
                                                        borderRadius: "5px"
                                                    }}
                                                >
                                                    <PersonComponent
                                                        {...person}
                                                        userId={person.id}
                                                        type={"person"}
                                                    ></PersonComponent>
                                                </div>
                                            </Col>
                                        )
                                    })}
                                </>
                            )}
                        </Row>
                    ) : (
                        <TileRow
                            key="staff"
                            iconVisible={true}
                            title={headerTitle}
                            titleVisible={false}
                            navLinkTextVisible={true}
                            hideShadows={true}
                            offsetLeft={props.containerOffsetLeft}
                            navLinkText={strings.receptionPage.participantsNavLinkText}
                            scrollBar={staff && staff?.length > 0}
                            childWidth={95 + 9}
                            childCount={staff?.length ?? 0}
                            customMargin="-45px 0px 0 0px"
                        >
                            {staff && (
                                <MobileTileWrapperSpeakers $count={staff?.length!}>
                                    {staff.map((person, index) => (
                                        <div style={{ width: 95, height: 95 }} key={index}>
                                            <PersonComponent {...person} type={"person"} userId={person.id}></PersonComponent>
                                        </div>
                                    ))}
                                </MobileTileWrapperSpeakers>
                            )}
                        </TileRow>
                    )}
                </MobileVersionContainer>
            </TeamRow>
            <PrivacyModal />
        </Col>
    )
}

const SessionRow = styled(Row)`
    line-height: 30px;
`
const ShareBookmarkDiv = styled.div`
    display: flex;
    justify-content: flex-end;
    font-size: 20px;
`
const ShareIcon = styled.div`
    cursor: pointer;
    margin-right: 20px;
    color: ${branding.primaryColor};
`

interface SessionDataProps {
    session: EventDate
}

export const SessionData: React.FunctionComponent<SessionDataProps> = (props) => {
    const languageState = useLanguageState()
    const strings = languageState.getStrings()
    const lang = languageState.getLanguage()
    const displayTicketIcon = props.session?.accessProvider === AccessProvider.TICKET

    const { showRecommendModal: showRecommendOrganizationModal, RecommendModal: OrganizationModal } = useRecommendModal()

    function getFormattedDate(date: string, start: string) {
        return (
            format(moment(date).toDate(), strings.eventTiming.eventDaysFormatPatternEvtDetailPage, {
                locale: lang === "de" ? de : en
            }) +
            (lang === "de" ? " um " : " at ") +
            start +
            (lang === "de" ? " Uhr" : "")
        ) //have to find a better way to do this but this works for now
    }
    const isLive = isEventDateLive(props.session)

    const categoriesState = useCategoriesState()
    const [pointsBadgeData, setPointsBadgeData] = useState<Category>()

    useEffect(() => {
        if (categoriesState.getCategories().length)
            setPointsBadgeData(categoriesState.getCategoryByAlias(branding.programSchedule.pointsBadgeCategoryAlias))
        // eslint-disable-next-line
    }, [])

    return (
        <DetailNavLink
            name={props.session.name}
            id={isLive && props.session.channel ? props.session.channel.id : props.session.id}
            type={isLive && props.session.channel ? "channel" : "eventdate"}
        >
            <SessionRow>
                <Col style={{ paddingRight: "0", flex: "0 0 20px", marginRight: "20px" }} xs={1}>
                    {IconVideo({ fill: branding.sideIconBar.sideIconColorDark })}
                </Col>
                <Col xs={9} style={{ paddingLeft: "0" }}>
                    <FormattedDatePar>{props.session.name}</FormattedDatePar>
                    <FormattedDateExtensionDiv>
                        {getFormattedDate(props.session.date, props.session.start)}
                    </FormattedDateExtensionDiv>
                    {props.session.location && <FormattedDateExtensionDiv>{props.session.location}</FormattedDateExtensionDiv>}
                    {pointsBadgeData &&
                        props.session.categories
                            ?.map((x) => x.alias)
                            ?.includes(branding.programSchedule.pointsBadgeCategoryAlias) && (
                            <PointsBadge
                                className={"ml-2"}
                                textColor={pointsBadgeData.colorText}
                                fillColor={pointsBadgeData.colorFill}
                                borderColor={pointsBadgeData.colorBorder}
                            >
                                {strings.programSchedule.pointsBadgeText}
                            </PointsBadge>
                        )}
                    {props.session.accessProvider !== AccessProvider.PUBLIC && (
                        <FormattedDateExtensionDiv>
                            {displayTicketIcon
                                ? IconTicket({ fill: branding.sideIconBar.sideIconColorDark, width: "18", height: "18" })
                                : IconLock({ fill: branding.sideIconBar.sideIconColorDark, width: "18", height: "18" })}
                        </FormattedDateExtensionDiv>
                    )}
                </Col>
                <Col xs={2} style={{ marginLeft: "calc(8.333333% - 55px)" }}>
                    <ShareBookmarkDiv>
                        <ShareIcon
                            onClick={(e) => {
                                e.preventDefault()
                                e.stopPropagation()
                                showRecommendOrganizationModal(
                                    ShareTargetType.EVENTDATE,
                                    props.session.id,
                                    buildDetailLink(props.session.id, props.session.name, "eventdate")
                                )
                            }}
                        >
                            {IconShare({ fill: branding.sideIconBar.sideIconColorDark })}
                        </ShareIcon>
                        <BookmarkWithToggle
                            newBookmarkItem={true}
                            fontSize={"25px"}
                            color={branding.sideIconBar.sideIconColorDark}
                            stroke={branding.sideIconBar.sideIconColorDark}
                            favIconBasic={true}
                            type="eventdate"
                            id={props.session.id}
                            name={props.session.name}
                        />
                    </ShareBookmarkDiv>
                </Col>
            </SessionRow>
            <OrganizationModal />
        </DetailNavLink>
    )
}

/* #region Coupon Data */
const CouponDetails = styled.div`
    cursor: pointer;
    padding-left: 10px;
`

const CouponNameLabel = styled.div`
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 10px;
    line-height: 1rem;
    margin-top: 2px;
    color: ${branding.coupons.couponsListLayoutTitleColor};
`

const CouponDescriptionLabel = styled.div`
    font-size: 14px;
    line-height: 0.8rem;
`

interface CouponDataProps {
    id: string
    companyId: string
    title: string
    teaser: string
    description: string
    url: string
    onAction: () => void
}

const CouponData: React.FunctionComponent<CouponDataProps> = (props) => {
    const location = useLocation()
    let currentLocation = location.pathname
    const goToCoupon = () => {
        props.onAction()
    }

    return (
        <SessionsContentCol>
            <SessionRow
                style={{ pointerEvents: props.url === null || props.url?.includes(currentLocation) ? "none" : "auto" }}
                onClick={() => goToCoupon()}
            >
                <Col style={{ paddingRight: "0", flex: "0 0 20px" }} xs={1}>
                    {IconCoupon({ fill: branding.sideIconBar.sideIconColorDark ?? branding.mainInfoColor })}
                </Col>
                <Col xs={11}>
                    <CouponDetails>
                        <CouponNameLabel>{props.title}</CouponNameLabel>
                        <CouponDescriptionLabel>{props.teaser || props.description}</CouponDescriptionLabel>
                    </CouponDetails>
                </Col>
            </SessionRow>
        </SessionsContentCol>
    )
}
/* #endregion */

/* #region  Links */
const LinkNameUrl = styled.p`
    font-size: 16px;
    display: inline-block;
    cursor: pointer;
    white-space: normal;
    word-break: break-word;
    margin-bottom: 0px;

    @media (max-width: 1600px) {
        font-size: 16px;
    }

    @media ${device.mobile} {
        font-size: 14px;
        font-weight: bold;
    }

    &:hover {
        opacity: 0.3;
    }
`
const LinkRow = styled(Row)`
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid ${branding.listDividerColor};
    padding: 25px 0;

    @media ${device.mobile} {
        margin-left: 5px !important;
        margin-right: 15px !important;
    }
`
const CopyToClipboardDiv = styled.div`
    cursor: pointer;
`

interface LinksProps {
    organizationId?: string
    organization?: Company
    links: Link[]
    tooltipMessage: string
    colXs?: number
    colPadding?: string
}

export const Links: React.FunctionComponent<LinksProps> = (props) => {
    const strings = useLanguageState().getStrings()
    const { showPrivacyPolicyModal, PrivacyModal } = usePrivacyPolicyModal()
    const loggedInUserId = useLoggedInState().user()?.profileId

    let links = props.links ?? []

    const { useMobileDesign } = useWindowDimensions()

    links = links.filter((link) => {
        return link.text && link.text?.length > 0
    })

    if (links.length === 0) return null

    return (
        <Col
            xs={props.colXs ?? 12}
            style={{
                padding: props.colPadding ? props.colPadding : useMobileDesign ? "5px 5px 35px 5px" : "5px"
            }}
        >
            <Row className={useMobileDesign ? "" : "mb-4"} style={{ marginLeft: "5px", marginRight: "5px" }}>
                <HeaderTitle>
                    {links.length > 1
                        ? strings.organizationDetailPageContent.linksTitle + " (" + props.links.length + ")"
                        : "Link (1)"}
                </HeaderTitle>
            </Row>
            {links.map((link, i) => (
                <LinkItem
                    link={link}
                    key={i}
                    onCopyLink={() => {
                        if (props.organizationId)
                            showPrivacyPolicyModal(props.organization!, (accepted) => {
                                navigator.clipboard.writeText(link.url)
                            })
                        else navigator.clipboard.writeText(link.url)
                    }}
                    onFollowLink={() => {
                        if (props.organizationId)
                            showPrivacyPolicyModal(props.organization!, (accepted) => {
                                trackVisit(loggedInUserId!, props.organizationId!, "LINK", link.url)
                                window.open(getProperUrl(link.url), "_blank")
                            })
                        else window.open(getProperUrl(link.url), "_blank")
                    }}
                    tooltipMessage={props.tooltipMessage}
                />
            ))}
            <PrivacyModal />
        </Col>
    )
}

interface LinkProps {
    link: Link
    tooltipMessage: string
    onCopyLink: () => void
    onFollowLink: () => void
}

const LinkItem: React.FunctionComponent<LinkProps> = (props) => {
    const [text, setText] = useState(props.link.text)
    const [tooltip, setTooltip] = useState(props.tooltipMessage)
    const { useMobileDesign } = useWindowDimensions()

    useEffect(() => {
        setText(props.link.text)
    }, [props.link])

    if (!props.link.text || props.link.text?.length === 0) {
        return null
    }

    return (
        <LinkRow className={useMobileDesign ? "mt-1 mx-0" : "mt-3 mx-0"}>
            <Col style={{ paddingRight: "0", flex: "0 0 20px", marginRight: "25px" }} xs={1} className="p-0">
                {IconLink({ fill: branding.sideIconBar.sideIconColorDark })}
            </Col>
            <Col
                style={{ paddingLeft: "0" }}
                xs={9}
                onMouseEnter={() => setText(props.link.url)}
                onMouseLeave={() => setText(props.link.text)}
            >
                <LinkNameUrl onClick={props.onFollowLink}>{text}</LinkNameUrl>
            </Col>
            <Col xs={2} style={{ marginLeft: "calc(8.333333% - 55px)" }} className="d-flex justify-content-end p-0">
                <CustomOverlayTrigger
                    placement="left"
                    delay={{ show: 250, hide: 400 }}
                    overlay={
                        <Tooltip id="tooltip" style={{ fontFamily: branding.font1 }}>
                            {tooltip}
                        </Tooltip>
                    }
                >
                    <CopyToClipboardDiv
                        onClick={() => {
                            props.onCopyLink()
                            setTooltip("copied")
                        }}
                        onMouseLeave={() =>
                            setTimeout(() => {
                                setTooltip(props.tooltipMessage)
                            }, 500)
                        }
                    >
                        {IconShareLink({ fill: branding.sideIconBar.sideIconColorDark })}
                    </CopyToClipboardDiv>
                </CustomOverlayTrigger>
            </Col>
        </LinkRow>
    )
}

const IframeButtonArea = styled.div`
    display: flex;
    flex-flow: row;
    justify-content: space-evenly;
`

const IframeButton = styled.button`
    display: flex;
    width: 150px;
    height: 50px;
    font-size: 14px;
    align-items: center;
    border: 1px solid;
    background: 0;
    justify-content: center;
    border-radius: 5px;
`
interface IframeSectionProps {
    src: string
    title: string
}

const IframeSection: React.FunctionComponent<IframeSectionProps> = (props) => {
    const strings = useLanguageState().getStrings()
    const iframeRef = useRef<HTMLIFrameElement>(null)

    function openFullscreen() {
        if (iframeRef?.current?.requestFullscreen) {
            iframeRef.current.requestFullscreen()
        } else {
            // this only happens in safari case
            const iframeSafari = iframeRef.current as unknown as HTMLElement & {
                webkitRequestFullscreen(): Promise<void>
            }
            if (iframeSafari?.webkitRequestFullscreen) iframeSafari.webkitRequestFullscreen()
        }
    }

    function openInNewTab() {
        window.open(props.src, "_blank")
    }

    return (
        <Row className="mt-5 pb-5 d-flex flex-column" style={{ marginLeft: "5px", marginRight: "5px" }}>
            <HeaderTitle>{strings.organizationDetailPageContent.showcase}</HeaderTitle>
            <iframe
                id="orgaIframe"
                ref={iframeRef}
                className="mt-5"
                style={{ height: "600px", borderRadius: "5px", border: branding.organizationDetailPageContent.iframeBorder }}
                title={props.title}
                src={props.src}
                allowFullScreen={true}
            ></iframe>
            <IframeButtonArea className="mx-auto w-50 mt-3">
                <IframeButton onClick={() => openFullscreen()}>
                    {strings.organizationDetailPageContent.fullscreenButton}
                </IframeButton>
                <IframeButton onClick={() => openInNewTab()}>{strings.organizationDetailPageContent.newTabButton}</IframeButton>
            </IframeButtonArea>
        </Row>
    )
}
/* #endregion */

const MobileCompanyHeaderWrapper = styled.div`
    background: #fff;
    padding-bottom: 10px;
    border-radius: 5px;

    @media ${device.tablet} {
        border-radius: 0;
    }
`
const MobileCompanyHeaderBannerContainer = styled.div`
    width: 100%;
    height: 105px;
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 5px 5px 0 0;

    & img {
        position: relative;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: left top;
        border-radius: 5px 5px 0 0;
    }
`

const MobileCompanyHeaderCompanyTitle = styled.div`
    font-family: ${branding.font1};
    font-weight: bold;
    font-size: 18px;
    line-height: 20px;
    margin-top: 60px;
    text-align: center;
`

const MobileCompanyHeaderMenuButton = styled.div`
    position: absolute;
    right: 3rem;
    margin-top: -100px;
    cursor: pointer;
    z-index: 1;
`

const MobileCompanyHeader: React.FunctionComponent<{ company?: Company }> = (props) => {
    const [showMenu, setShowMenu] = useState<boolean>(false)
    const userState = useLoggedInState()

    const headerImageUrl = (exhibitor: Company): string => {
        if (
            branding.organizationDetailPageContent.defaultHeaderBasisPremiumTypes.includes(exhibitor.basisPremium) ||
            !exhibitor.backgroundImageURL
        )
            return "/branding/default_brand_card.jpg"
        else return exhibitor.backgroundImageURL
    }

    return (
        <MobileSectionWrapper>
            <MobileCompanyHeaderWrapper>
                <MobileCompanyHeaderBannerContainer>
                    <img src={headerImageUrl(props.company!)} alt="" />
                    {isUserEdited(userState) && (
                        <MobileCompanyHeaderMenuButton
                            onClick={() => {
                                setShowMenu(true)
                            }}
                        >
                            {IconThreeDotsMenu({ fill: "#fff" })}
                        </MobileCompanyHeaderMenuButton>
                    )}
                </MobileCompanyHeaderBannerContainer>
                <div style={{ position: "relative", width: "100%" }}>
                    <CompanyLogoDiv
                        style={{
                            position: "absolute",
                            marginTop: "-40px",
                            left: 0,
                            right: 0,
                            marginLeft: "auto",
                            marginRight: "auto"
                        }}
                    >
                        {props.company?.pictureURL ? (
                            <CompanyLogo src={props.company?.pictureURL} alt="" />
                        ) : branding.exhibitorsPageContent.defaultLogoVisibleOnCompanyTiles ? (
                            <CompanyLogo src={"/branding/rsz_defaultgrey.png"} />
                        ) : (
                            <h2 style={{ fontFamily: branding.font1 }}>{props.company?.initials}</h2>
                        )}
                    </CompanyLogoDiv>
                </div>
                <MobileCompanyHeaderCompanyTitle>{props.company?.name}</MobileCompanyHeaderCompanyTitle>

                {showMenu && <CompanyMenuModal company={props.company!} handleClose={() => setShowMenu(false)} />}
            </MobileCompanyHeaderWrapper>
        </MobileSectionWrapper>
    )
}

export const ModalRoot = styled(Modal)<{ marginTop?: string }>`
    font-family: ${branding.font1};
    color: ${branding.mainInfoColor};

    .modal-content {
        border-radius: 5px;

        &::before {
            content: "";
            position: absolute;
            border-style: solid;
            border-width: 10px 12px;
            border-color: transparent transparent #fff transparent;
            right: 1.5rem;
            top: -20px;
        }
    }

    .modal-dialog {
        margin-top: ${(props) => props.marginTop ?? "100px"};
        margin-left: auto;
        margin-right: auto;
        width: calc(100% - 25px);
        border-radius: 5px;
    }
`

export function onBookmark(favoriteState: any, company?: Company | Exhibitor, user?: any) {
    if (company && user) {
        let date = new Date()
        date.setMinutes(date.getMinutes() - 1)
        favoriteState.toggle("organization", company?.id)
        const isFavorite = favoriteState.is("organization", company?.id)
        syncFavorites({
            profileId: user.profileId,
            body: {
                currentTime: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"), //"2020-01-01 12:00:00",
                lastSyncTime: favoriteState.getLastSyncTime(),
                changedFavorites: [
                    {
                        id: company?.id,
                        kind: "ORGANIZATION",
                        deleted: !isFavorite,
                        lastModified: moment(new Date()).format("YYYY-MM-DD HH:mm:ss")
                    }
                ]
            }
        }).then(() => {
            favoriteState.setLastSyncTime(new Date())
        })
    }
}

export function getCompanyMenuModalItems(
    mobileAppDownload: boolean,
    favoriteState: any,
    strings: any,
    showRecommendModal: (shareType: ShareTargetType, entityId: string, link: string) => void,
    setShowRequestMeetingModal: (value: boolean) => void,
    company?: Company | Exhibitor,
    user?: any
) {
    const menuItems: MenuItemProps[] = []

    // Bookmark organization
    const isBookmarked = favoriteState.is("organization", company?.id || "")
    menuItems.push({
        title: strings.organizationDetailPageContent.bookmark,
        icon: isBookmarked
            ? branding.defaultToggleIcon
                ? IconBookmarkFilled({ fill: branding.sideIconBar.sideIconColorDark })
                : IconBookmarkToggle({ fill: branding.sideIconBar.sideIconColorDark })
            : IconBookmarkToggle({ fill: branding.sideIconBar.sideIconColorDark }),
        onClick: () => onBookmark(favoriteState, company, user)
    })

    // Request contact
    /*menuItems.push({
        title: strings.organizationDetailPageContent.registerInterest,
        icon: IconCall({ fill: branding.sideIconBar.sideIconColorDark }),
        onClick: () => onRequestContact(),
     })*/

    // Request meeting
    menuItems.push({
        disabled: isPostEventPhase,
        title: strings.organizationDetailPageContent.requestMeeting,
        icon: IconMeetingSchedule({ fill: branding.sideIconBar.sideIconColorDark }),
        onClick: () => {
            trackVisit(user?.profileId!, company?.id!, "CALENDARENTRY#CLICK")
            setShowRequestMeetingModal(true)
        }
    })

    // Recommend organization
    menuItems.push({
        title: strings.organizationDetailPageContent.recommend,
        icon: IconShare({ fill: branding.sideIconBar.sideIconColorDark }),
        onClick: () =>
            showRecommendModal(
                ShareTargetType.ORGANIZATION,
                company?.id!,
                buildDetailLink(company?.id!, company?.name!, "organization")
            )
    })

    //Download vCard
    /*if (branding.organizationDetailPageContent.vCardDownloadAvailable) {
        menuItems.push({
            disabled: !hasAccessToOrganization(userState.user()!, company?.id!),
            title: strings.contactEntry.downloadVCardTitle,
            icon: IconDownloadVCard({ fill: branding.sideIconBar.sideIconColorDark }),
            onClick: () => doVCard(company!),
        })
    }*/

    //Download mobile app
    if (branding.contextMenuBranding.appDownloadEnabled && mobileAppDownload) {
        menuItems.push({
            title: strings.contextMenuBranding.appDownloadButtonText,
            hint: strings.contextMenuBranding.appDownloadButtonText,
            icon: IconMobile({ fill: branding.sideIconBar.sideIconColorDark }),
            onClick: () => {
                onAppDownloadClick(strings)
            }
        })
    }

    return menuItems
}

const CompanyMenuModal: React.FunctionComponent<{ company?: Company; handleClose: () => void }> = (props) => {
    const strings = useLanguageState().getStrings()
    const favoriteState = useFavoriteState()
    const userState = useLoggedInState()
    const user = userState.user()
    const { RecommendModal, showRecommendModal } = useRecommendModal()

    const [showRequestMeetingModal, setShowRequestMeetingModal] = useState(false)
    const [showRequestOrganizationModal, setShowRequestOrganizationModal] = useState(false)

    return (
        <>
            <ModalRoot show={true} animation={false} onHide={() => props.handleClose()}>
                <ContextMenu
                    collapsed={false}
                    items={() =>
                        getCompanyMenuModalItems(
                            true,
                            favoriteState,
                            strings,
                            showRecommendModal,
                            setShowRequestMeetingModal,
                            props.company,
                            user
                        )
                    }
                />
            </ModalRoot>
            <RecommendModal />
            {showRequestMeetingModal && user && (
                <CalendarEntryModal
                    viewMode={CalendarEntryModalViewMode.CREATE}
                    organizationId={props.company?.id!}
                    close={() => setShowRequestMeetingModal(false)}
                />
            )}
            {showRequestOrganizationModal && (
                <SayHelloModal
                    organizationModal={true}
                    targetId={props.company?.id!}
                    handleClose={() => setShowRequestOrganizationModal(false)}
                />
            )}
        </>
    )
}

const ImageSliderWrapper = styled.div`
    background-color: #c9c9c9;
    height: 248px;
    border-radius: 5px;

    .slick-slider {
        height: 215px;
    }

    .slick-dots {
        bottom: -30px;
    }

    .slick-dots li {
        width: 5px;
    }

    .slick-dots li.slick-active button:before {
        //color: #fff;
    }

    & .slick-prev {
        left: 20px;
        margin-top: 20px;
        z-index: 1;
    }

    & .slick-next {
        right: 20px;
        margin-top: 20px;
        z-index: 1;
    }
`

const ProductTitleMobile = styled.div`
    font-weight: 900;
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 20px;
    font-family: ${branding.font1};
`

const ProductBasicInfoMobile = styled.div`
    padding: 10px 20px 10px 10px;
    min-height: 115px;
`

const ProductTeaserMobile = styled.div`
    font-weight: 400;
    font-style: normal;
    font-size: 14px;
    line-height: 20px;
    text-align: justify;
    font-family: ${branding.font1};
`

const ImageContainer = styled.div`
    height: 248px;
    width: 100%;
    background-repeat: no-repeat;
    background-position: center;

    & img {
        position: relative;
        z-index: -1;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center center;
        border-radius: 5px 5px 0 0;
    }
`
const IconWrapper = styled.div`
    &::before {
        content: none;
    }
`
const TrademarkLogoDiv = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #d9d9d9;
    border-radius: 5px;
    width: 95px;
    height: 95px;
    padding: 20px;
    background: #fff;
    float: left;
    margin-right: 20px;
    margin-bottom: 20px;
`

export const MobileProductHeader: React.FunctionComponent<{
    entity?: Product | Trademark | JobOffer
    type: "product" | "trademark" | "joboffer"
}> = (props) => {
    let attachments = filterMedia(props.entity?.attachments!, true)
    let images: Attachment[] = []
    const organization =
        props.type === "joboffer"
            ? (props.entity as JobOffer).organization
            : (props.entity as Product | Trademark)?.organizations.length
            ? (props.entity as Product | Trademark)?.organizations[0]
            : undefined
    const organizationId = organization?.id

    const user = useLoggedInState().user()
    const { PrivacyModal, showPrivacyPolicyModal } = usePrivacyPolicyModal()
    const strings = useLanguageState().getStrings()

    const [showMore, setShowMore] = useState(false)
    const [showMoreBtnClicked, setShowMoreBtnClicked] = useState(false)
    const history = useHistory()

    const [selectedAtt, setSelectedAtt] = useState<Attachment>()
    const [showMediaSlider, setShowMediaSlider] = useState(false)

    useEffect(() => {
        if ((props.entity as Product) && (props.entity as Product)?.stands!)
            (props.entity as Product)?.stands?.length! > 3 ? setShowMore(true) : setShowMore(false)
        else setShowMore(false)
        // eslint-disable-next-line
    }, [props.entity])

    const renderImages = () => {
        if (props.type === "product" && props.entity?.pictureURL && attachments.length === 0) {
            images.push({
                id: props.entity?.id ?? "",
                title: props.entity?.name ?? "",
                description: "",
                url: props.entity?.pictureURL ?? "",
                largeThumbnailUrl: props.entity?.pictureURL ?? "",
                smallThumbnailUrl: props.entity?.pictureURL ?? "",
                contentType: "JPG"
            })
        }

        attachments.forEach((att) => {
            images.push(att)
        })

        return images.map((image: Attachment, index: number) => (
            <ImageContainer key={index} onClick={() => onFocusImageClicked(image)}>
                <img src={image.url} alt="" />
            </ImageContainer>
        ))
    }

    const onFocusImageClicked = (attachment: Attachment) => {
        if (attachments.length === 0) return
        setSelectedAtt(attachment)

        if (organizationId && organization) {
            showPrivacyPolicyModal(organization, (accepted) => {
                trackVisit(user!.profileId, organizationId!, "MEDIA#PREVIEW", selectedAtt?.id)
                setShowMediaSlider(true)
            })
        } else {
            setShowMediaSlider(true)
        }
    }

    return (
        <MobileSectionWrapper>
            {attachments.length === 0 && props.entity?.entityType === "product" && !props.entity?.pictureURL ? null : (
                <ImageSliderWrapper>
                    <Slider
                        autoplay={true}
                        autoplaySpeed={3000}
                        dots={true}
                        nextArrow={
                            <IconWrapper>
                                {IconArrowRightCarousel({
                                    width: "19px",
                                    height: "30px",
                                    fill: branding.sideIconBar.sideIconColorDark
                                })}
                            </IconWrapper>
                        }
                        prevArrow={
                            <IconWrapper>
                                {IconArrowLeftCarousel({
                                    width: "19px",
                                    height: "30px",
                                    fill: branding.sideIconBar.sideIconColorDark
                                })}
                            </IconWrapper>
                        }
                    >
                        {renderImages()}
                    </Slider>
                </ImageSliderWrapper>
            )}

            <ProductBasicInfoMobile>
                {(props.type === "trademark" || props.type === "joboffer") && (
                    <TrademarkLogoDiv>
                        {props.entity?.pictureURL ? (
                            <CompanyLogo src={props.entity?.pictureURL} alt="" />
                        ) : branding.exhibitorsPageContent.defaultLogoVisibleOnCompanyTiles ? (
                            <CompanyLogo src={"/branding/rsz_defaultgrey.png"} />
                        ) : (
                            <h2 style={{ fontFamily: branding.font1 }}>{props.entity?.initials}</h2>
                        )}
                    </TrademarkLogoDiv>
                )}
                {props.entity?.name && (
                    <Row>
                        <Col xs={10}>
                            <ProductTitleMobile>{props.entity?.name}</ProductTitleMobile>
                        </Col>
                        <Col xs={2} className="p-0 text-right">
                            <BookmarkWithToggle
                                newBookmarkItem={true}
                                fontSize={"25px"}
                                color={branding.sideIconBar.sideIconColorDark}
                                favIconBasic={true}
                                type={props.type}
                                id={props.entity?.id}
                                name={props.entity?.name}
                            />
                        </Col>
                    </Row>
                )}
                {props.type === "joboffer" && <JobOfferDetails joboffer={props.entity as JobOffer} />}
                {props.type !== "joboffer" && props.entity?.description && props.entity?.description.text && (
                    <ProductTeaserMobile>
                        {props.entity?.description.text?.split("\\n")?.map((item, i) => (
                            <span key={i}>
                                {item}
                                <br />
                            </span>
                        ))}
                    </ProductTeaserMobile>
                )}
                {props.type === "product" && (props.entity as Product)?.stands && (props.entity as Product)?.stands?.length! > 0 && (
                    <DetailsAdditionalInfoDiv style={{ flex: 1, display: "flex", flexDirection: "row" }}>
                        <HalleStandSectionMobileView className="product">
                            <p>{strings.productDetailPageContent.halleStandSectionTitle}</p>
                            {(props.entity as Product)?.stands
                                .slice(0, showMoreBtnClicked ? (props.entity as Product)?.stands.length : 3)
                                .map((stand, idx) => {
                                    return (
                                        <HalleStandSingleMobileView
                                            onClick={() => {
                                                if (!branding.organizationDetailPageContent.halleStandLinkEnabled) return

                                                history.push(
                                                    hallplanOverviewRoute + "/" + stand.id.split("__")[0] + "--" + stand.id
                                                )
                                            }}
                                            key={idx}
                                        >
                                            {stand.standName || stand.displayName}
                                        </HalleStandSingleMobileView>
                                    )
                                })}
                            {(props.entity as Product)?.stands.length > 3 && showMore && (
                                <ShowMoreDiv>
                                    <ShowMoreBtn onClick={() => setShowMoreBtnClicked(!showMoreBtnClicked)}>
                                        {showMoreBtnClicked
                                            ? strings.productDetailPageContent.showLessText
                                            : strings.productDetailPageContent.showMoreText}
                                    </ShowMoreBtn>
                                    <div style={{ marginLeft: "7px", marginBottom: "2px" }}>
                                        {showMoreBtnClicked
                                            ? IconShowLess({
                                                  fill: branding.sideIconBar.sideIconColorDark,
                                                  width: "12",
                                                  height: "12"
                                              })
                                            : IconShowMore({
                                                  fill: branding.sideIconBar.sideIconColorDark,
                                                  width: "12",
                                                  height: "12"
                                              })}
                                    </div>
                                </ShowMoreDiv>
                            )}
                        </HalleStandSectionMobileView>
                    </DetailsAdditionalInfoDiv>
                )}
            </ProductBasicInfoMobile>

            <PrivacyModal />
            {attachments &&
                attachments.length > 0 &&
                ReactDOM.createPortal(
                    showMediaSlider && (
                        <div>
                            <DesktopVersionContainer>
                                <MediaSlider media={images} selectedAtt={selectedAtt} setShowMediaSlider={setShowMediaSlider} />
                            </DesktopVersionContainer>
                            <MobileVersionContainer>
                                <MediaSliderForMobileView
                                    media={images}
                                    selectedAtt={selectedAtt}
                                    setShowMediaSlider={setShowMediaSlider}
                                />
                            </MobileVersionContainer>
                        </div>
                    ),
                    document.body
                )}
        </MobileSectionWrapper>
    )
}
